(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === elm$core$Basics$EQ ? 0 : ord === elm$core$Basics$LT ? -1 : 1;
	}));
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File === 'function' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[94m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.cX.aI === region.dj.aI)
	{
		return 'on line ' + region.cX.aI;
	}
	return 'on lines ' + region.cX.aI + ' through ' + region.dj.aI;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = elm$core$Set$toList(x);
		y = elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = elm$core$Dict$toList(x);
		y = elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = elm$core$Dict$toList(x);
		y = elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? elm$core$Basics$LT : n ? elm$core$Basics$GT : elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});



function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return word
		? elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? elm$core$Maybe$Nothing
		: elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? elm$core$Maybe$Just(n) : elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




/**_UNUSED/
function _Json_errorToString(error)
{
	return elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? elm$core$Result$Ok(value)
		: (value instanceof String)
			? elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return (elm$core$Result$isOk(result)) ? result : elm$core$Result$Err(A2(elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!elm$core$Result$isOk(result))
					{
						return elm$core$Result$Err(A2(elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return elm$core$Result$Ok(elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if (elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return elm$core$Result$Err(elm$json$Json$Decode$OneOf(elm$core$List$reverse(errors)));

		case 1:
			return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!elm$core$Result$isOk(result))
		{
			return elm$core$Result$Err(A2(elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2(elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return elm$core$Result$Err(A2(elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.ek,
		impl.ex,
		impl.ev,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	result = init(result.a);
	var model = result.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		result = A2(update, msg, model);
		stepper(model = result.a, viewMetadata);
		_Platform_dispatchEffects(managers, result.b, subscriptions(model));
	}

	_Platform_dispatchEffects(managers, result.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				p: bag.n,
				q: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.q)
		{
			x = temp.p(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		r: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		r: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].r;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2(elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2(elm$json$Json$Decode$map, func, handler.a)
				:
			A3(elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		dz: func(record.dz),
		cZ: record.cZ,
		cU: record.cU
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.dz;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.cZ;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.cU) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.ek,
		impl.ex,
		impl.ev,
		function(sendToApp, initialModel) {
			var view = impl.ez;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.ek,
		impl.ex,
		impl.ev,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.aR && impl.aR(sendToApp)
			var view = impl.ez;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.d6);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.ew) && (_VirtualDom_doc.title = title = doc.ew);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.eo;
	var onUrlRequest = impl.ep;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		aR: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.dM === next.dM
							&& curr.dq === next.dq
							&& curr.dH.a === next.dH.a
						)
							? elm$browser$Browser$Internal(next)
							: elm$browser$Browser$External(href)
					));
				}
			});
		},
		ek: function(flags)
		{
			return A3(impl.ek, flags, _Browser_getUrl(), key);
		},
		ez: impl.ez,
		ex: impl.ex,
		ev: impl.ev
	});
}

function _Browser_getUrl()
{
	return elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return elm$core$Result$isOk(result) ? elm$core$Maybe$Just(result.a) : elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { eg: 'hidden', d7: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { eg: 'mozHidden', d7: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { eg: 'msHidden', d7: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { eg: 'webkitHidden', d7: 'webkitvisibilitychange' }
		: { eg: 'hidden', d7: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail(elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		dS: _Browser_getScene(),
		d2: {
			k: _Browser_window.pageXOffset,
			l: _Browser_window.pageYOffset,
			aw: _Browser_doc.documentElement.clientWidth,
			ah: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		aw: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		ah: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			dS: {
				aw: node.scrollWidth,
				ah: node.scrollHeight
			},
			d2: {
				k: node.scrollLeft,
				l: node.scrollTop,
				aw: node.clientWidth,
				ah: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			dS: _Browser_getScene(),
			d2: {
				k: x,
				l: y,
				aw: _Browser_doc.documentElement.clientWidth,
				ah: _Browser_doc.documentElement.clientHeight
			},
			ea: {
				k: x + rect.left,
				l: y + rect.top,
				aw: rect.width,
				ah: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2(elm$core$Task$perform, elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}
var author$project$Mousikea$Music$Par = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var author$project$Mousikea$Music$Volume = function (a) {
	return {$: 0, a: a};
};
var author$project$Mousikea$Util$Ratio$Rational = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var elm$core$Array$foldr = F3(
	function (func, baseCase, _n0) {
		var tree = _n0.c;
		var tail = _n0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3(elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3(elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			elm$core$Elm$JsArray$foldr,
			helper,
			A3(elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var elm$core$Basics$EQ = 1;
var elm$core$Basics$LT = 0;
var elm$core$List$cons = _List_cons;
var elm$core$Array$toList = function (array) {
	return A3(elm$core$Array$foldr, elm$core$List$cons, _List_Nil, array);
};
var elm$core$Basics$GT = 2;
var elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3(elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var elm$core$Dict$toList = function (dict) {
	return A3(
		elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var elm$core$Dict$keys = function (dict) {
	return A3(
		elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2(elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var elm$core$Set$toList = function (_n0) {
	var dict = _n0;
	return elm$core$Dict$keys(dict);
};
var elm$core$Basics$eq = _Utils_equal;
var elm$core$Basics$modBy = _Basics_modBy;
var author$project$Mousikea$Util$Ratio$gcd = F2(
	function (a, b) {
		gcd:
		while (true) {
			if (!b) {
				return a;
			} else {
				var $temp$a = b,
					$temp$b = A2(elm$core$Basics$modBy, b, a);
				a = $temp$a;
				b = $temp$b;
				continue gcd;
			}
		}
	});
var elm$core$Basics$idiv = _Basics_idiv;
var elm$core$Basics$lt = _Utils_lt;
var elm$core$Basics$mul = _Basics_mul;
var elm$core$Basics$negate = function (n) {
	return -n;
};
var author$project$Mousikea$Util$Ratio$normalize = function (_n0) {
	var p = _n0.a;
	var q = _n0.b;
	var k = A2(author$project$Mousikea$Util$Ratio$gcd, p, q) * ((q < 0) ? (-1) : 1);
	return A2(author$project$Mousikea$Util$Ratio$Rational, (p / k) | 0, (q / k) | 0);
};
var author$project$Mousikea$Util$Ratio$over = F2(
	function (x, y) {
		return (y < 0) ? author$project$Mousikea$Util$Ratio$normalize(
			A2(author$project$Mousikea$Util$Ratio$Rational, -x, -y)) : author$project$Mousikea$Util$Ratio$normalize(
			A2(author$project$Mousikea$Util$Ratio$Rational, x, y));
	});
var author$project$Mousikea$Music$en = A2(author$project$Mousikea$Util$Ratio$over, 1, 8);
var author$project$Mousikea$Music$Seq = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var author$project$Mousikea$Music$Prim = function (a) {
	return {$: 0, a: a};
};
var author$project$Mousikea$Primitive$Rest = function (a) {
	return {$: 1, a: a};
};
var author$project$Mousikea$Music$rest = function (dur) {
	return author$project$Mousikea$Music$Prim(
		author$project$Mousikea$Primitive$Rest(dur));
};
var author$project$Mousikea$Util$Ratio$fromInt = function (x) {
	return A2(author$project$Mousikea$Util$Ratio$over, x, 1);
};
var author$project$Mousikea$Music$zero = author$project$Mousikea$Util$Ratio$fromInt(0);
var author$project$Mousikea$Music$empty = author$project$Mousikea$Music$rest(author$project$Mousikea$Music$zero);
var elm$core$Basics$add = _Basics_add;
var elm$core$Basics$gt = _Utils_gt;
var elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var elm$core$List$reverse = function (list) {
	return A3(elm$core$List$foldl, elm$core$List$cons, _List_Nil, list);
};
var elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							elm$core$List$foldl,
							fn,
							acc,
							elm$core$List$reverse(r4)) : A4(elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4(elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var author$project$Mousikea$Music$line = A2(elm$core$List$foldr, author$project$Mousikea$Music$Seq, author$project$Mousikea$Music$empty);
var author$project$Mousikea$Music$Modify = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var author$project$Mousikea$Primitive$Note = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var author$project$Mousikea$Primitive$map = F2(
	function (func, prim) {
		if (!prim.$) {
			var dur = prim.a;
			var x = prim.b;
			return A2(
				author$project$Mousikea$Primitive$Note,
				dur,
				func(x));
		} else {
			var dur = prim.a;
			return author$project$Mousikea$Primitive$Rest(dur);
		}
	});
var author$project$Mousikea$Music$map = F2(
	function (func, m) {
		switch (m.$) {
			case 0:
				var p = m.a;
				return author$project$Mousikea$Music$Prim(
					A2(author$project$Mousikea$Primitive$map, func, p));
			case 1:
				var m1 = m.a;
				var m2 = m.b;
				return A2(
					author$project$Mousikea$Music$Seq,
					A2(author$project$Mousikea$Music$map, func, m1),
					A2(author$project$Mousikea$Music$map, func, m2));
			case 2:
				var m1 = m.a;
				var m2 = m.b;
				return A2(
					author$project$Mousikea$Music$Par,
					A2(author$project$Mousikea$Music$map, func, m1),
					A2(author$project$Mousikea$Music$map, func, m2));
			default:
				var control = m.a;
				var m_ = m.b;
				return A2(
					author$project$Mousikea$Music$Modify,
					control,
					A2(author$project$Mousikea$Music$map, func, m_));
		}
	});
var author$project$Mousikea$Music$Percussion = {$: 128};
var author$project$Mousikea$Music$Instrument = function (a) {
	return {$: 2, a: a};
};
var author$project$Mousikea$Music$instrument = F2(
	function (i, m) {
		return A2(
			author$project$Mousikea$Music$Modify,
			author$project$Mousikea$Music$Instrument(i),
			m);
	});
var author$project$Mousikea$Music$note = F2(
	function (dur, p) {
		return author$project$Mousikea$Music$Prim(
			A2(author$project$Mousikea$Primitive$Note, dur, p));
	});
var author$project$Mousikea$Music$A = 27;
var author$project$Mousikea$Music$As = 29;
var author$project$Mousikea$Music$B = 32;
var author$project$Mousikea$Music$C = 2;
var author$project$Mousikea$Music$Cs = 4;
var author$project$Mousikea$Music$D = 7;
var author$project$Mousikea$Music$Ds = 9;
var author$project$Mousikea$Music$E = 13;
var author$project$Mousikea$Music$F = 16;
var author$project$Mousikea$Music$Fs = 19;
var author$project$Mousikea$Music$G = 22;
var author$project$Mousikea$Music$Gs = 24;
var elm$core$Basics$sub = _Basics_sub;
var author$project$Mousikea$Music$indexToPitchClass = function (n) {
	indexToPitchClass:
	while (true) {
		switch (n) {
			case 0:
				return 2;
			case 1:
				return 4;
			case 2:
				return 7;
			case 3:
				return 9;
			case 4:
				return 13;
			case 5:
				return 16;
			case 6:
				return 19;
			case 7:
				return 22;
			case 8:
				return 24;
			case 9:
				return 27;
			case 10:
				return 29;
			case 11:
				return 32;
			default:
				var other = n;
				if (other > 0) {
					var $temp$n = other - 12;
					n = $temp$n;
					continue indexToPitchClass;
				} else {
					var $temp$n = other + 12;
					n = $temp$n;
					continue indexToPitchClass;
				}
		}
	}
};
var author$project$Mousikea$Music$pitch = function (ap) {
	var _n0 = _Utils_Tuple2(
		(ap / 12) | 0,
		A2(elm$core$Basics$modBy, 12, ap));
	var oct = _n0.a;
	var n = _n0.b;
	return _Utils_Tuple2(
		author$project$Mousikea$Music$indexToPitchClass(n),
		oct - 1);
};
var author$project$Mousikea$PercussionSound$fromEnum = function (pc) {
	switch (pc) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		case 6:
			return 6;
		case 7:
			return 7;
		case 8:
			return 8;
		case 9:
			return 9;
		case 10:
			return 10;
		case 11:
			return 11;
		case 12:
			return 12;
		case 13:
			return 13;
		case 14:
			return 14;
		case 15:
			return 15;
		case 16:
			return 16;
		case 17:
			return 17;
		case 18:
			return 18;
		case 19:
			return 19;
		case 20:
			return 20;
		case 21:
			return 21;
		case 22:
			return 22;
		case 23:
			return 23;
		case 24:
			return 24;
		case 25:
			return 25;
		case 26:
			return 26;
		case 27:
			return 27;
		case 28:
			return 28;
		case 29:
			return 29;
		case 30:
			return 30;
		case 31:
			return 31;
		case 32:
			return 32;
		case 33:
			return 33;
		case 34:
			return 34;
		case 35:
			return 35;
		case 36:
			return 36;
		case 37:
			return 37;
		case 38:
			return 38;
		case 39:
			return 39;
		case 40:
			return 40;
		case 41:
			return 41;
		case 42:
			return 42;
		case 43:
			return 43;
		case 44:
			return 44;
		case 45:
			return 45;
		default:
			return 46;
	}
};
var author$project$Mousikea$Music$perc = F2(
	function (ps, dur) {
		return A2(
			author$project$Mousikea$Music$instrument,
			author$project$Mousikea$Music$Percussion,
			A2(
				author$project$Mousikea$Music$note,
				dur,
				author$project$Mousikea$Music$pitch(
					author$project$Mousikea$PercussionSound$fromEnum(ps) + 35)));
	});
var author$project$Mousikea$Music$qn = A2(author$project$Mousikea$Util$Ratio$over, 1, 4);
var elm$core$Basics$le = _Utils_le;
var author$project$Mousikea$Music$times = F2(
	function (n, m) {
		return (n <= 0) ? author$project$Mousikea$Music$empty : A2(
			author$project$Mousikea$Music$Seq,
			m,
			A2(author$project$Mousikea$Music$times, n - 1, m));
	});
var author$project$Mousikea$PercussionSound$AcousticBassDrum = 0;
var author$project$Mousikea$PercussionSound$AcousticSnare = 3;
var author$project$Mousikea$PercussionSound$ClosedHiHat = 7;
var author$project$Mousikea$PercussionSound$HandClap = 4;
var author$project$Mousikea$Examples$Drums$simpleBeat = A2(
	author$project$Mousikea$Music$map,
	function (p) {
		return _Utils_Tuple2(
			p,
			_List_fromArray(
				[
					author$project$Mousikea$Music$Volume(60)
				]));
	},
	A2(
		author$project$Mousikea$Music$times,
		16,
		A2(
			author$project$Mousikea$Music$Par,
			A2(
				author$project$Mousikea$Music$times,
				2,
				author$project$Mousikea$Music$line(
					_List_fromArray(
						[
							author$project$Mousikea$Music$rest(author$project$Mousikea$Music$qn),
							A2(
							author$project$Mousikea$Music$Par,
							A2(author$project$Mousikea$Music$perc, 3, author$project$Mousikea$Music$qn),
							A2(author$project$Mousikea$Music$perc, 4, author$project$Mousikea$Music$qn))
						]))),
			A2(
				author$project$Mousikea$Music$Par,
				A2(
					author$project$Mousikea$Music$times,
					8,
					A2(author$project$Mousikea$Music$perc, 7, author$project$Mousikea$Music$en)),
				A2(
					author$project$Mousikea$Music$times,
					4,
					A2(author$project$Mousikea$Music$perc, 0, author$project$Mousikea$Music$qn))))));
var author$project$Mousikea$Music$a = F2(
	function (octave, dur) {
		return A2(
			author$project$Mousikea$Music$note,
			dur,
			_Utils_Tuple2(27, octave));
	});
var author$project$Mousikea$Music$b = F2(
	function (octave, dur) {
		return A2(
			author$project$Mousikea$Music$note,
			dur,
			_Utils_Tuple2(32, octave));
	});
var author$project$Mousikea$Examples$Mine$playground = A2(
	author$project$Mousikea$Music$map,
	function (p) {
		return _Utils_Tuple2(
			p,
			_List_fromArray(
				[
					author$project$Mousikea$Music$Volume(60)
				]));
	},
	author$project$Mousikea$Music$line(
		_List_fromArray(
			[
				A2(author$project$Mousikea$Music$a, 4, author$project$Mousikea$Music$en),
				A2(author$project$Mousikea$Music$b, 4, author$project$Mousikea$Music$en)
			])));
var author$project$Mousikea$Examples$Mine$music = author$project$Mousikea$Examples$Mine$playground;
var author$project$Mousikea$Generator$LeadSheetPart = F2(
	function (duration, scale) {
		return {bo: duration, at: scale};
	});
var elm$core$Basics$identity = function (x) {
	return x;
};
var elm$random$Random$Generator = elm$core$Basics$identity;
var elm$random$Random$constant = function (value) {
	return function (seed) {
		return _Utils_Tuple2(value, seed);
	};
};
var elm$core$Basics$remainderBy = _Basics_remainderBy;
var elm$core$Bitwise$and = _Bitwise_and;
var elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var elm$random$Random$Seed = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var elm$random$Random$next = function (_n0) {
	var state0 = _n0.a;
	var incr = _n0.b;
	return A2(elm$random$Random$Seed, ((state0 * 1664525) + incr) >>> 0, incr);
};
var elm$core$Bitwise$xor = _Bitwise_xor;
var elm$random$Random$peel = function (_n0) {
	var state = _n0.a;
	var word = (state ^ (state >>> ((state >>> 28) + 4))) * 277803737;
	return ((word >>> 22) ^ word) >>> 0;
};
var elm$random$Random$int = F2(
	function (a, b) {
		return function (seed0) {
			var _n0 = (_Utils_cmp(a, b) < 0) ? _Utils_Tuple2(a, b) : _Utils_Tuple2(b, a);
			var lo = _n0.a;
			var hi = _n0.b;
			var range = (hi - lo) + 1;
			if (!((range - 1) & range)) {
				return _Utils_Tuple2(
					(((range - 1) & elm$random$Random$peel(seed0)) >>> 0) + lo,
					elm$random$Random$next(seed0));
			} else {
				var threshhold = (((-range) >>> 0) % range) >>> 0;
				var accountForBias = function (seed) {
					accountForBias:
					while (true) {
						var x = elm$random$Random$peel(seed);
						var seedN = elm$random$Random$next(seed);
						if (_Utils_cmp(x, threshhold) < 0) {
							var $temp$seed = seedN;
							seed = $temp$seed;
							continue accountForBias;
						} else {
							return _Utils_Tuple2((x % range) + lo, seedN);
						}
					}
				};
				return accountForBias(seed0);
			}
		};
	});
var elm$random$Random$map3 = F4(
	function (func, _n0, _n1, _n2) {
		var genA = _n0;
		var genB = _n1;
		var genC = _n2;
		return function (seed0) {
			var _n3 = genA(seed0);
			var a = _n3.a;
			var seed1 = _n3.b;
			var _n4 = genB(seed1);
			var b = _n4.a;
			var seed2 = _n4.b;
			var _n5 = genC(seed2);
			var c = _n5.a;
			var seed3 = _n5.b;
			return _Utils_Tuple2(
				A3(func, a, b, c),
				seed3);
		};
	});
var elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var elm$random$Random$addOne = function (value) {
	return _Utils_Tuple2(1, value);
};
var elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var elm$core$List$sum = function (numbers) {
	return A3(elm$core$List$foldl, elm$core$Basics$add, 0, numbers);
};
var elm$core$Basics$fdiv = _Basics_fdiv;
var elm$core$Basics$toFloat = _Basics_toFloat;
var elm$random$Random$float = F2(
	function (a, b) {
		return function (seed0) {
			var seed1 = elm$random$Random$next(seed0);
			var range = elm$core$Basics$abs(b - a);
			var n1 = elm$random$Random$peel(seed1);
			var n0 = elm$random$Random$peel(seed0);
			var lo = (134217727 & n1) * 1.0;
			var hi = (67108863 & n0) * 1.0;
			var val = ((hi * 1.34217728e8) + lo) / 9.007199254740992e15;
			var scaled = (val * range) + a;
			return _Utils_Tuple2(
				scaled,
				elm$random$Random$next(seed1));
		};
	});
var elm$random$Random$getByWeight = F3(
	function (_n0, others, countdown) {
		getByWeight:
		while (true) {
			var weight = _n0.a;
			var value = _n0.b;
			if (!others.b) {
				return value;
			} else {
				var second = others.a;
				var otherOthers = others.b;
				if (_Utils_cmp(
					countdown,
					elm$core$Basics$abs(weight)) < 1) {
					return value;
				} else {
					var $temp$_n0 = second,
						$temp$others = otherOthers,
						$temp$countdown = countdown - elm$core$Basics$abs(weight);
					_n0 = $temp$_n0;
					others = $temp$others;
					countdown = $temp$countdown;
					continue getByWeight;
				}
			}
		}
	});
var elm$random$Random$map = F2(
	function (func, _n0) {
		var genA = _n0;
		return function (seed0) {
			var _n1 = genA(seed0);
			var a = _n1.a;
			var seed1 = _n1.b;
			return _Utils_Tuple2(
				func(a),
				seed1);
		};
	});
var elm$random$Random$weighted = F2(
	function (first, others) {
		var normalize = function (_n0) {
			var weight = _n0.a;
			return elm$core$Basics$abs(weight);
		};
		var total = normalize(first) + elm$core$List$sum(
			A2(elm$core$List$map, normalize, others));
		return A2(
			elm$random$Random$map,
			A2(elm$random$Random$getByWeight, first, others),
			A2(elm$random$Random$float, 0, total));
	});
var elm$random$Random$uniform = F2(
	function (value, valueList) {
		return A2(
			elm$random$Random$weighted,
			elm$random$Random$addOne(value),
			A2(elm$core$List$map, elm$random$Random$addOne, valueList));
	});
var author$project$Mousikea$Generator$randomPrim = F3(
	function (pitches, durs, thres) {
		var _n0 = _Utils_Tuple2(pitches, durs);
		if (_n0.a.b && _n0.b.b) {
			var _n1 = _n0.a;
			var p = _n1.a;
			var ps = _n1.b;
			var _n2 = _n0.b;
			var d = _n2.a;
			var ds = _n2.b;
			var mkPrim = F3(
				function (ap, dur, vol) {
					return (_Utils_cmp(vol, thres) < 0) ? author$project$Mousikea$Music$rest(dur) : A2(
						author$project$Mousikea$Music$note,
						dur,
						_Utils_Tuple2(ap, vol));
				});
			return A4(
				elm$random$Random$map3,
				mkPrim,
				A2(elm$random$Random$uniform, p, ps),
				A2(elm$random$Random$uniform, d, ds),
				A2(elm$random$Random$int, 0, 127));
		} else {
			return elm$random$Random$constant(author$project$Mousikea$Music$empty);
		}
	});
var author$project$Mousikea$Util$Ratio$addsub = F3(
	function (f, _n0, _n1) {
		var a = _n0.a;
		var b = _n0.b;
		var c = _n1.a;
		var d = _n1.b;
		return author$project$Mousikea$Util$Ratio$normalize(
			A2(
				author$project$Mousikea$Util$Ratio$Rational,
				A2(f, a * d, b * c),
				b * d));
	});
var author$project$Mousikea$Util$Ratio$add = author$project$Mousikea$Util$Ratio$addsub(elm$core$Basics$add);
var author$project$Mousikea$Util$Ratio$multiply = F2(
	function (_n0, _n1) {
		var a = _n0.a;
		var b = _n0.b;
		var c = _n1.a;
		var d = _n1.b;
		return author$project$Mousikea$Util$Ratio$normalize(
			A2(author$project$Mousikea$Util$Ratio$Rational, a * c, b * d));
	});
var author$project$Mousikea$Util$Ratio$divide = F2(
	function (r, _n0) {
		var c = _n0.a;
		var d = _n0.b;
		return A2(
			author$project$Mousikea$Util$Ratio$multiply,
			r,
			A2(author$project$Mousikea$Util$Ratio$Rational, d, c));
	});
var author$project$Mousikea$Util$Ratio$div = author$project$Mousikea$Util$Ratio$divide;
var author$project$Mousikea$Util$Ratio$denominator = function (_n0) {
	var b = _n0.b;
	return b;
};
var author$project$Mousikea$Util$Ratio$numerator = function (_n0) {
	var a = _n0.a;
	return a;
};
var author$project$Mousikea$Util$Ratio$rel = F3(
	function (relop, a, b) {
		return A2(
			relop,
			author$project$Mousikea$Util$Ratio$numerator(a) * author$project$Mousikea$Util$Ratio$denominator(b),
			author$project$Mousikea$Util$Ratio$numerator(b) * author$project$Mousikea$Util$Ratio$denominator(a));
	});
var author$project$Mousikea$Util$Ratio$gt = F2(
	function (a, b) {
		return A3(author$project$Mousikea$Util$Ratio$rel, elm$core$Basics$gt, a, b);
	});
var author$project$Mousikea$Util$Ratio$max = F2(
	function (a, b) {
		return A2(author$project$Mousikea$Util$Ratio$gt, a, b) ? a : b;
	});
var author$project$Mousikea$Music$duration = function (m) {
	duration:
	while (true) {
		switch (m.$) {
			case 0:
				if (!m.a.$) {
					var _n1 = m.a;
					var dur = _n1.a;
					return dur;
				} else {
					var dur = m.a.a;
					return dur;
				}
			case 1:
				var m1 = m.a;
				var m2 = m.b;
				return A2(
					author$project$Mousikea$Util$Ratio$add,
					author$project$Mousikea$Music$duration(m1),
					author$project$Mousikea$Music$duration(m2));
			case 2:
				var m1 = m.a;
				var m2 = m.b;
				return A2(
					author$project$Mousikea$Util$Ratio$max,
					author$project$Mousikea$Music$duration(m1),
					author$project$Mousikea$Music$duration(m2));
			default:
				if (!m.a.$) {
					var r = m.a.a;
					var m_ = m.b;
					return A2(
						author$project$Mousikea$Util$Ratio$div,
						author$project$Mousikea$Music$duration(m_),
						r);
				} else {
					var m_ = m.b;
					var $temp$m = m_;
					m = $temp$m;
					continue duration;
				}
		}
	}
};
var author$project$Mousikea$Music$Tempo = function (a) {
	return {$: 0, a: a};
};
var author$project$Mousikea$Music$tempo = F2(
	function (r, m) {
		return A2(
			author$project$Mousikea$Music$Modify,
			author$project$Mousikea$Music$Tempo(r),
			m);
	});
var author$project$Mousikea$Util$Ratio$le = F2(
	function (a, b) {
		return A3(author$project$Mousikea$Util$Ratio$rel, elm$core$Basics$le, a, b);
	});
var author$project$Mousikea$Util$Ratio$lt = F2(
	function (a, b) {
		return A3(author$project$Mousikea$Util$Ratio$rel, elm$core$Basics$lt, a, b);
	});
var author$project$Mousikea$Util$Ratio$min = F2(
	function (a, b) {
		return A2(author$project$Mousikea$Util$Ratio$lt, a, b) ? a : b;
	});
var author$project$Mousikea$Util$Ratio$mul = author$project$Mousikea$Util$Ratio$multiply;
var author$project$Mousikea$Util$Ratio$subtract = author$project$Mousikea$Util$Ratio$addsub(elm$core$Basics$sub);
var author$project$Mousikea$Util$Ratio$sub = author$project$Mousikea$Util$Ratio$subtract;
var author$project$Mousikea$Music$cut = F2(
	function (dur, m) {
		if (A2(author$project$Mousikea$Util$Ratio$le, dur, author$project$Mousikea$Music$zero)) {
			return author$project$Mousikea$Music$empty;
		} else {
			switch (m.$) {
				case 0:
					if (!m.a.$) {
						var _n1 = m.a;
						var oldD = _n1.a;
						var p = _n1.b;
						var dur_ = A2(
							author$project$Mousikea$Util$Ratio$max,
							A2(author$project$Mousikea$Util$Ratio$min, oldD, dur),
							author$project$Mousikea$Music$zero);
						return A2(author$project$Mousikea$Util$Ratio$gt, dur_, author$project$Mousikea$Music$zero) ? A2(author$project$Mousikea$Music$note, dur_, p) : author$project$Mousikea$Music$empty;
					} else {
						var oldD = m.a.a;
						return author$project$Mousikea$Music$rest(
							A2(
								author$project$Mousikea$Util$Ratio$max,
								A2(author$project$Mousikea$Util$Ratio$min, oldD, dur),
								author$project$Mousikea$Music$zero));
					}
				case 2:
					var m1 = m.a;
					var m2 = m.b;
					return A2(
						author$project$Mousikea$Music$Par,
						A2(author$project$Mousikea$Music$cut, dur, m1),
						A2(author$project$Mousikea$Music$cut, dur, m2));
				case 1:
					var m1 = m.a;
					var m2 = m.b;
					var music1 = A2(author$project$Mousikea$Music$cut, dur, m1);
					var music2 = A2(
						author$project$Mousikea$Music$cut,
						A2(
							author$project$Mousikea$Util$Ratio$sub,
							dur,
							author$project$Mousikea$Music$duration(music1)),
						m2);
					return A2(author$project$Mousikea$Music$Seq, music1, music2);
				default:
					if (!m.a.$) {
						var r = m.a.a;
						var m_ = m.b;
						return A2(
							author$project$Mousikea$Music$tempo,
							r,
							A2(
								author$project$Mousikea$Music$cut,
								A2(author$project$Mousikea$Util$Ratio$mul, dur, r),
								m_));
					} else {
						var control = m.a;
						var m_ = m.b;
						return A2(
							author$project$Mousikea$Music$Modify,
							control,
							A2(author$project$Mousikea$Music$cut, dur, m_));
					}
			}
		}
	});
var elm$random$Random$andThen = F2(
	function (callback, _n0) {
		var genA = _n0;
		return function (seed) {
			var _n1 = genA(seed);
			var result = _n1.a;
			var newSeed = _n1.b;
			var _n2 = callback(result);
			var genB = _n2;
			return genB(newSeed);
		};
	});
var author$project$Mousikea$Generator$randomMel = F4(
	function (dur, pitches, durs, thres) {
		var rndMel = function (acc) {
			return A2(
				author$project$Mousikea$Util$Ratio$gt,
				author$project$Mousikea$Music$duration(acc),
				dur) ? elm$random$Random$constant(
				A2(author$project$Mousikea$Music$cut, dur, acc)) : A2(
				elm$random$Random$andThen,
				function (m) {
					return rndMel(
						A2(author$project$Mousikea$Music$Seq, m, acc));
				},
				A3(author$project$Mousikea$Generator$randomPrim, pitches, durs, thres));
		};
		return rndMel(author$project$Mousikea$Music$empty);
	});
var elm$random$Random$map2 = F3(
	function (func, _n0, _n1) {
		var genA = _n0;
		var genB = _n1;
		return function (seed0) {
			var _n2 = genA(seed0);
			var a = _n2.a;
			var seed1 = _n2.b;
			var _n3 = genB(seed1);
			var b = _n3.a;
			var seed2 = _n3.b;
			return _Utils_Tuple2(
				A2(func, a, b),
				seed2);
		};
	});
var author$project$Mousikea$Generator$withRandomDur = F3(
	function (durs, thres, f) {
		if (durs.b) {
			var d = durs.a;
			var ds = durs.b;
			var mkPrim = F2(
				function (dur, vol) {
					return (_Utils_cmp(vol, thres) < 0) ? author$project$Mousikea$Music$rest(dur) : A2(f, dur, vol);
				});
			return A3(
				elm$random$Random$map2,
				mkPrim,
				A2(elm$random$Random$uniform, d, ds),
				A2(elm$random$Random$int, 0, 70));
		} else {
			return elm$random$Random$constant(author$project$Mousikea$Music$empty);
		}
	});
var author$project$Mousikea$Music$AcousticBass = {$: 32};
var author$project$Mousikea$Music$RhodesPiano = {$: 4};
var author$project$Mousikea$Music$Vibraphone = {$: 11};
var author$project$Mousikea$Music$chord = A2(elm$core$List$foldr, author$project$Mousikea$Music$Par, author$project$Mousikea$Music$empty);
var author$project$Mousikea$Music$dqn = A2(author$project$Mousikea$Util$Ratio$over, 3, 8);
var author$project$Mousikea$Music$pcToInt = function (pc) {
	switch (pc) {
		case 0:
			return -2;
		case 1:
			return -1;
		case 2:
			return 0;
		case 4:
			return 1;
		case 6:
			return 2;
		case 3:
			return 0;
		case 5:
			return 1;
		case 7:
			return 2;
		case 9:
			return 3;
		case 12:
			return 4;
		case 8:
			return 2;
		case 10:
			return 3;
		case 13:
			return 4;
		case 15:
			return 5;
		case 18:
			return 6;
		case 11:
			return 3;
		case 14:
			return 4;
		case 16:
			return 5;
		case 19:
			return 6;
		case 21:
			return 7;
		case 17:
			return 5;
		case 20:
			return 6;
		case 22:
			return 7;
		case 24:
			return 8;
		case 26:
			return 9;
		case 23:
			return 7;
		case 25:
			return 8;
		case 27:
			return 9;
		case 29:
			return 10;
		case 31:
			return 11;
		case 28:
			return 9;
		case 30:
			return 10;
		case 32:
			return 11;
		case 33:
			return 12;
		default:
			return 13;
	}
};
var elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var elm$core$Basics$or = _Basics_or;
var elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2(elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _n0 = f(mx);
		if (!_n0.$) {
			var x = _n0.a;
			return A2(elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			elm$core$List$foldr,
			elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var elm$core$List$length = function (xs) {
	return A3(
		elm$core$List$foldl,
		F2(
			function (_n0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var elm$core$List$map2 = _List_map2;
var elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2(elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var elm$core$List$range = F2(
	function (lo, hi) {
		return A3(elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			elm$core$List$map2,
			f,
			A2(
				elm$core$List$range,
				0,
				elm$core$List$length(xs) - 1),
			xs);
	});
var elm$core$Basics$False = 1;
var elm$core$Basics$True = 0;
var elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var elm$core$Maybe$Nothing = {$: 1};
var elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return elm$core$Maybe$Nothing;
		}
	});
var elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var elm$random$Random$listHelp = F4(
	function (revList, n, gen, seed) {
		listHelp:
		while (true) {
			if (n < 1) {
				return _Utils_Tuple2(revList, seed);
			} else {
				var _n0 = gen(seed);
				var value = _n0.a;
				var newSeed = _n0.b;
				var $temp$revList = A2(elm$core$List$cons, value, revList),
					$temp$n = n - 1,
					$temp$gen = gen,
					$temp$seed = newSeed;
				revList = $temp$revList;
				n = $temp$n;
				gen = $temp$gen;
				seed = $temp$seed;
				continue listHelp;
			}
		}
	});
var elm$random$Random$list = F2(
	function (n, _n0) {
		var gen = _n0;
		return function (seed) {
			return A4(elm$random$Random$listHelp, _List_Nil, n, gen, seed);
		};
	});
var elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return elm$core$Maybe$Just(x);
	} else {
		return elm$core$Maybe$Nothing;
	}
};
var elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? elm$core$Maybe$Nothing : elm$core$List$head(
			A2(elm$core$List$drop, idx, xs));
	});
var author$project$Mousikea$Generator$mkBossa = function (leadSheet) {
	if (!leadSheet.b) {
		return elm$random$Random$constant(author$project$Mousikea$Music$empty);
	} else {
		var part = leadSheet.a;
		var tail = leadSheet.b;
		var voicing = A2(
			elm$core$List$filter,
			function (p) {
				return A2(
					elm$core$List$member,
					A2(elm$core$Basics$modBy, 12, p),
					A2(
						elm$core$List$filterMap,
						function (_n2) {
							var i = _n2.a;
							var pc = _n2.b;
							return ((!i) || ((i === 2) || (i === 6))) ? elm$core$Maybe$Just(
								author$project$Mousikea$Music$pcToInt(pc)) : elm$core$Maybe$Nothing;
						},
						A2(elm$core$List$indexedMap, elm$core$Tuple$pair, part.at)));
			},
			A2(elm$core$List$range, 60, 71));
		var notesFromScale = A2(
			elm$core$List$filter,
			function (p) {
				return A2(
					elm$core$List$member,
					A2(elm$core$Basics$modBy, 12, p),
					A2(elm$core$List$map, author$project$Mousikea$Music$pcToInt, part.at));
			},
			A2(elm$core$List$range, 60, 71));
		var mkBass = F2(
			function (root, fifth) {
				return A2(
					author$project$Mousikea$Music$instrument,
					author$project$Mousikea$Music$AcousticBass,
					A2(
						author$project$Mousikea$Music$times,
						8,
						author$project$Mousikea$Music$line(
							_List_fromArray(
								[
									A2(
									author$project$Mousikea$Music$note,
									author$project$Mousikea$Music$dqn,
									_Utils_Tuple2(root, 100)),
									A2(
									author$project$Mousikea$Music$note,
									author$project$Mousikea$Music$en,
									_Utils_Tuple2(fifth, 80)),
									A2(
									author$project$Mousikea$Music$note,
									author$project$Mousikea$Music$dqn,
									_Utils_Tuple2(fifth, 100)),
									A2(
									author$project$Mousikea$Music$note,
									author$project$Mousikea$Music$en,
									_Utils_Tuple2(root, 80))
								]))));
			});
		var mel = A2(
			elm$random$Random$map,
			author$project$Mousikea$Music$instrument(author$project$Mousikea$Music$Vibraphone),
			A4(
				author$project$Mousikea$Generator$randomMel,
				part.bo,
				notesFromScale,
				_List_fromArray(
					[author$project$Mousikea$Music$qn, author$project$Mousikea$Music$en, author$project$Mousikea$Music$en, author$project$Mousikea$Music$en]),
				40));
		var comping = A2(
			elm$random$Random$map,
			A2(
				elm$core$Basics$composeR,
				author$project$Mousikea$Music$line,
				author$project$Mousikea$Music$instrument(author$project$Mousikea$Music$RhodesPiano)),
			A2(
				elm$random$Random$list,
				16,
				A3(
					author$project$Mousikea$Generator$withRandomDur,
					_List_fromArray(
						[author$project$Mousikea$Music$qn, author$project$Mousikea$Music$qn, author$project$Mousikea$Music$qn, author$project$Mousikea$Music$qn, author$project$Mousikea$Music$qn, author$project$Mousikea$Music$qn, author$project$Mousikea$Music$en]),
					20,
					F2(
						function (dur, _n1) {
							return A2(
								author$project$Mousikea$Music$map,
								function (p) {
									return _Utils_Tuple2(p, 25);
								},
								author$project$Mousikea$Music$chord(
									A2(
										elm$core$List$map,
										author$project$Mousikea$Music$note(dur),
										voicing)));
						}))));
		var bassRoot = A2(
			elm$core$Maybe$andThen,
			function (pc) {
				return A2(
					elm_community$list_extra$List$Extra$find,
					function (p) {
						return _Utils_eq(
							A2(elm$core$Basics$modBy, 12, p),
							author$project$Mousikea$Music$pcToInt(pc));
					},
					A2(elm$core$List$range, 36, 48));
			},
			A2(elm_community$list_extra$List$Extra$getAt, 0, part.at));
		var bassFifth = A2(
			elm$core$Maybe$andThen,
			function (pc) {
				return A2(
					elm_community$list_extra$List$Extra$find,
					function (p) {
						return _Utils_eq(
							A2(elm$core$Basics$modBy, 12, p),
							author$project$Mousikea$Music$pcToInt(pc));
					},
					A2(elm$core$List$range, 36, 48));
			},
			A2(elm_community$list_extra$List$Extra$getAt, 4, part.at));
		var bass = A2(
			elm$core$Maybe$withDefault,
			author$project$Mousikea$Music$empty,
			A3(elm$core$Maybe$map2, mkBass, bassRoot, bassFifth));
		var rythm = A2(
			elm$random$Random$map,
			author$project$Mousikea$Music$cut(part.bo),
			A2(
				elm$random$Random$map,
				author$project$Mousikea$Music$Par(bass),
				comping));
		var rythmAndMel = A3(elm$random$Random$map2, author$project$Mousikea$Music$Par, mel, rythm);
		return A3(
			elm$random$Random$map2,
			author$project$Mousikea$Music$Seq,
			rythmAndMel,
			author$project$Mousikea$Generator$mkBossa(tail));
	}
};
var author$project$Mousikea$Music$fromPitchVolume = author$project$Mousikea$Music$map(
	function (_n0) {
		var p = _n0.a;
		var v = _n0.b;
		return _Utils_Tuple2(
			p,
			_List_fromArray(
				[
					author$project$Mousikea$Music$Volume(v)
				]));
	});
var author$project$Mousikea$PercussionSound$Claves = 40;
var author$project$Mousikea$PercussionSound$Maracas = 35;
var author$project$Mousikea$Generator$percussion = function () {
	var maracas = A2(
		author$project$Mousikea$Music$times,
		16,
		A2(author$project$Mousikea$Music$perc, 35, author$project$Mousikea$Music$en));
	var cl = author$project$Mousikea$Music$perc(40);
	var clave = author$project$Mousikea$Music$line(
		_List_fromArray(
			[
				author$project$Mousikea$Music$rest(author$project$Mousikea$Music$qn),
				cl(author$project$Mousikea$Music$dqn),
				cl(author$project$Mousikea$Music$dqn),
				cl(author$project$Mousikea$Music$dqn),
				cl(author$project$Mousikea$Music$dqn),
				cl(author$project$Mousikea$Music$qn)
			]));
	return author$project$Mousikea$Music$fromPitchVolume(
		A2(
			author$project$Mousikea$Music$map,
			function (p) {
				return _Utils_Tuple2(p, 40);
			},
			A2(author$project$Mousikea$Music$Par, maracas, clave)));
}();
var author$project$Mousikea$Music$Af = 25;
var author$project$Mousikea$Music$Bf = 30;
var author$project$Mousikea$Music$Df = 5;
var author$project$Mousikea$Music$Ef = 10;
var author$project$Mousikea$Music$Gf = 20;
var author$project$Mousikea$Music$bn = author$project$Mousikea$Util$Ratio$fromInt(2);
var author$project$Mousikea$Music$fromAbsPitchVolume = author$project$Mousikea$Music$map(
	function (_n0) {
		var ap = _n0.a;
		var v = _n0.b;
		return _Utils_Tuple2(
			author$project$Mousikea$Music$pitch(ap),
			_List_fromArray(
				[
					author$project$Mousikea$Music$Volume(v)
				]));
	});
var author$project$Mousikea$Music$hn = A2(author$project$Mousikea$Util$Ratio$over, 1, 2);
var author$project$Mousikea$Music$wn = author$project$Mousikea$Util$Ratio$fromInt(1);
var elm$core$Basics$append = _Utils_append;
var author$project$Mousikea$Generator$blueBossa = function () {
	var gDom = _List_fromArray(
		[22, 25, 30, 32, 7, 10, 16]);
	var fMin = _List_fromArray(
		[16, 22, 25, 30, 2, 7, 10]);
	var eMin = _List_fromArray(
		[10, 16, 20, 25, 30, 2, 5]);
	var dfMaj = _List_fromArray(
		[5, 10, 16, 20, 25, 30, 2]);
	var dHalfDim = _List_fromArray(
		[7, 10, 16, 22, 25, 30, 2]);
	var cMin = _List_fromArray(
		[2, 7, 10, 16, 22, 25, 30]);
	var part1 = _List_fromArray(
		[
			A2(author$project$Mousikea$Generator$LeadSheetPart, author$project$Mousikea$Music$bn, cMin),
			A2(author$project$Mousikea$Generator$LeadSheetPart, author$project$Mousikea$Music$bn, fMin),
			A2(author$project$Mousikea$Generator$LeadSheetPart, author$project$Mousikea$Music$wn, dHalfDim),
			A2(author$project$Mousikea$Generator$LeadSheetPart, author$project$Mousikea$Music$wn, gDom),
			A2(author$project$Mousikea$Generator$LeadSheetPart, author$project$Mousikea$Music$bn, cMin)
		]);
	var afDom = _List_fromArray(
		[25, 30, 2, 5, 10, 16, 20]);
	var part2 = _List_fromArray(
		[
			A2(author$project$Mousikea$Generator$LeadSheetPart, author$project$Mousikea$Music$wn, eMin),
			A2(author$project$Mousikea$Generator$LeadSheetPart, author$project$Mousikea$Music$wn, afDom),
			A2(author$project$Mousikea$Generator$LeadSheetPart, author$project$Mousikea$Music$bn, dfMaj),
			A2(author$project$Mousikea$Generator$LeadSheetPart, author$project$Mousikea$Music$wn, dHalfDim),
			A2(author$project$Mousikea$Generator$LeadSheetPart, author$project$Mousikea$Music$wn, gDom),
			A2(author$project$Mousikea$Generator$LeadSheetPart, author$project$Mousikea$Music$wn, cMin),
			A2(author$project$Mousikea$Generator$LeadSheetPart, author$project$Mousikea$Music$hn, dHalfDim),
			A2(author$project$Mousikea$Generator$LeadSheetPart, author$project$Mousikea$Music$hn, gDom)
		]);
	return A2(
		elm$random$Random$map,
		A2(
			elm$core$Basics$composeR,
			author$project$Mousikea$Music$fromAbsPitchVolume,
			A2(
				elm$core$Basics$composeR,
				author$project$Mousikea$Music$Par(
					A2(author$project$Mousikea$Music$times, 16, author$project$Mousikea$Generator$percussion)),
				author$project$Mousikea$Music$tempo(
					A2(author$project$Mousikea$Util$Ratio$over, 3, 2)))),
		author$project$Mousikea$Generator$mkBossa(
			_Utils_ap(
				part1,
				_Utils_ap(
					part2,
					_Utils_ap(part1, part2)))));
}();
var elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3(elm$core$List$foldr, elm$core$List$cons, ys, xs);
		}
	});
var elm$core$List$concat = function (lists) {
	return A3(elm$core$List$foldr, elm$core$List$append, _List_Nil, lists);
};
var elm$core$List$concatMap = F2(
	function (f, list) {
		return elm$core$List$concat(
			A2(elm$core$List$map, f, list));
	});
var elm_community$list_extra$List$Extra$andThen = elm$core$List$concatMap;
var author$project$Mousikea$Generator$bossa = function () {
	var product = F3(
		function (f, xs, ys) {
			return A2(
				elm_community$list_extra$List$Extra$andThen,
				function (x) {
					return A2(
						elm$core$List$map,
						f(x),
						ys);
				},
				xs);
		});
	var cDorian = _List_fromArray(
		[2, 7, 10, 16, 22, 27, 30]);
	var scales = A3(
		product,
		function (root) {
			return elm$core$List$map(
				function (pc) {
					return author$project$Mousikea$Music$indexToPitchClass(
						author$project$Mousikea$Music$pcToInt(pc) + root);
				});
		},
		A2(elm$core$List$range, 0, 11),
		_List_fromArray(
			[cDorian]));
	var parts = function (n) {
		if (!scales.b) {
			return elm$random$Random$constant(_List_Nil);
		} else {
			var x = scales.a;
			var xs = scales.b;
			return A2(
				elm$random$Random$map,
				elm$core$List$map(
					function (scale) {
						return {bo: author$project$Mousikea$Music$wn, at: scale};
					}),
				A2(
					elm$random$Random$list,
					n,
					A2(elm$random$Random$uniform, x, xs)));
		}
	};
	return A2(
		elm$random$Random$map,
		A2(
			elm$core$Basics$composeR,
			author$project$Mousikea$Music$fromAbsPitchVolume,
			A2(
				elm$core$Basics$composeR,
				author$project$Mousikea$Music$Par(
					A2(author$project$Mousikea$Music$times, 16, author$project$Mousikea$Generator$percussion)),
				author$project$Mousikea$Music$tempo(
					A2(author$project$Mousikea$Util$Ratio$over, 3, 2)))),
		A2(
			elm$random$Random$andThen,
			author$project$Mousikea$Generator$mkBossa,
			parts(32)));
}();
var author$project$Mousikea$Generator$randomness = function () {
	var mel2 = A2(
		elm$random$Random$map,
		author$project$Mousikea$Music$instrument(author$project$Mousikea$Music$AcousticBass),
		A4(
			author$project$Mousikea$Generator$randomMel,
			author$project$Mousikea$Util$Ratio$fromInt(32),
			_List_fromArray(
				[36, 36, 43, 43, 46, 48]),
			_List_fromArray(
				[author$project$Mousikea$Music$hn, author$project$Mousikea$Music$qn, author$project$Mousikea$Music$qn, author$project$Mousikea$Music$qn]),
			20));
	var mel1 = A2(
		elm$random$Random$map,
		author$project$Mousikea$Music$instrument(author$project$Mousikea$Music$Vibraphone),
		A4(
			author$project$Mousikea$Generator$randomMel,
			author$project$Mousikea$Util$Ratio$fromInt(32),
			_List_fromArray(
				[60, 62, 63, 65, 67, 68, 70, 72, 73, 75, 77, 79]),
			_List_fromArray(
				[author$project$Mousikea$Music$qn, author$project$Mousikea$Music$en, author$project$Mousikea$Music$en, author$project$Mousikea$Music$en]),
			60));
	return A2(
		elm$random$Random$map,
		author$project$Mousikea$Music$tempo(
			author$project$Mousikea$Util$Ratio$fromInt(2)),
		A3(elm$random$Random$map2, author$project$Mousikea$Music$Par, mel1, mel2));
}();
var author$project$Mousikea$Music$scaleDurations = F2(
	function (r, m) {
		switch (m.$) {
			case 0:
				if (!m.a.$) {
					var _n1 = m.a;
					var dur = _n1.a;
					var p = _n1.b;
					return A2(
						author$project$Mousikea$Music$note,
						A2(author$project$Mousikea$Util$Ratio$div, dur, r),
						p);
				} else {
					var dur = m.a.a;
					return author$project$Mousikea$Music$rest(
						A2(author$project$Mousikea$Util$Ratio$div, dur, r));
				}
			case 1:
				var m1 = m.a;
				var m2 = m.b;
				return A2(
					author$project$Mousikea$Music$Seq,
					A2(author$project$Mousikea$Music$scaleDurations, r, m1),
					A2(author$project$Mousikea$Music$scaleDurations, r, m2));
			case 2:
				var m1 = m.a;
				var m2 = m.b;
				return A2(
					author$project$Mousikea$Music$Par,
					A2(author$project$Mousikea$Music$scaleDurations, r, m1),
					A2(author$project$Mousikea$Music$scaleDurations, r, m2));
			default:
				var control = m.a;
				var m_ = m.b;
				return A2(
					author$project$Mousikea$Music$Modify,
					control,
					A2(author$project$Mousikea$Music$scaleDurations, r, m_));
		}
	});
var author$project$Mousikea$Music$absPitch = function (_n0) {
	var pc = _n0.a;
	var oct = _n0.b;
	return (12 * (oct + 1)) + author$project$Mousikea$Music$pcToInt(pc);
};
var author$project$Mousikea$Music$trans = F2(
	function (i, p) {
		return author$project$Mousikea$Music$pitch(
			author$project$Mousikea$Music$absPitch(p) + i);
	});
var author$project$Mousikea$Music$shiftPitches1 = function (k) {
	return author$project$Mousikea$Music$map(
		function (_n0) {
			var p = _n0.a;
			var xs = _n0.b;
			return _Utils_Tuple2(
				A2(author$project$Mousikea$Music$trans, k, p),
				xs);
		});
};
var author$project$Mousikea$Midi$MEvent$applyControls = function (m) {
	switch (m.$) {
		case 3:
			switch (m.a.$) {
				case 0:
					var r = m.a.a;
					var m_ = m.b;
					return A2(
						author$project$Mousikea$Music$scaleDurations,
						r,
						author$project$Mousikea$Midi$MEvent$applyControls(m_));
				case 1:
					var k = m.a.a;
					var m_ = m.b;
					return A2(
						author$project$Mousikea$Music$shiftPitches1,
						k,
						author$project$Mousikea$Midi$MEvent$applyControls(m_));
				default:
					var x = m.a;
					var m_ = m.b;
					return A2(
						author$project$Mousikea$Music$Modify,
						x,
						author$project$Mousikea$Midi$MEvent$applyControls(m_));
			}
		case 1:
			var m1 = m.a;
			var m2 = m.b;
			return A2(
				author$project$Mousikea$Music$Seq,
				author$project$Mousikea$Midi$MEvent$applyControls(m1),
				author$project$Mousikea$Midi$MEvent$applyControls(m2));
		case 2:
			var m1 = m.a;
			var m2 = m.b;
			return A2(
				author$project$Mousikea$Music$Par,
				author$project$Mousikea$Midi$MEvent$applyControls(m1),
				author$project$Mousikea$Midi$MEvent$applyControls(m2));
		default:
			var x = m;
			return x;
	}
};
var author$project$Mousikea$Midi$MEvent$merge = F2(
	function (es1, es2) {
		var _n0 = _Utils_Tuple2(es1, es2);
		if (!_n0.a.b) {
			var es2_ = _n0.b;
			return es2_;
		} else {
			if (!_n0.b.b) {
				var es1_ = _n0.a;
				return es1_;
			} else {
				var _n1 = _n0.a;
				var h1 = _n1.a;
				var t1 = _n1.b;
				var _n2 = _n0.b;
				var h2 = _n2.a;
				var t2 = _n2.b;
				return A2(author$project$Mousikea$Util$Ratio$lt, h1.z, h2.z) ? A2(
					elm$core$List$cons,
					h1,
					A2(author$project$Mousikea$Midi$MEvent$merge, t1, es2)) : A2(
					elm$core$List$cons,
					h2,
					A2(author$project$Mousikea$Midi$MEvent$merge, es1, t2));
			}
		}
	});
var author$project$Mousikea$Midi$MEvent$noteToMEvent = F3(
	function (ctx, dur, _n0) {
		var p = _n0.a;
		var nas = _n0.b;
		var nasFun = F2(
			function (na, ev) {
				switch (na.$) {
					case 0:
						var v = na.a;
						return _Utils_update(
							ev,
							{S: v});
					case 3:
						var pms = na.a;
						return _Utils_update(
							ev,
							{cB: pms});
					default:
						return ev;
				}
			});
		var e0 = {
			y: A2(author$project$Mousikea$Util$Ratio$mul, dur, ctx.aJ),
			dg: ctx.bB,
			cB: _List_Nil,
			dh: author$project$Mousikea$Music$absPitch(p),
			z: ctx.aK,
			S: ctx.bC
		};
		return A3(elm$core$List$foldr, nasFun, e0, nas);
	});
var author$project$Mousikea$Music$Dyn = function (a) {
	return {$: 0, a: a};
};
var author$project$Mousikea$Music$Loudness = function (a) {
	return {$: 4, a: a};
};
var author$project$Mousikea$Util$Ratio$toFloat = function (_n0) {
	var a = _n0.a;
	var b = _n0.b;
	return a / b;
};
var elm$core$Basics$round = _Basics_round;
var author$project$Mousikea$Util$Ratio$round = A2(elm$core$Basics$composeR, author$project$Mousikea$Util$Ratio$toFloat, elm$core$Basics$round);
var elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return elm$core$Maybe$Just(
				f(value));
		} else {
			return elm$core$Maybe$Nothing;
		}
	});
var author$project$Mousikea$Midi$MEvent$musicToMEvents = F2(
	function (ctx, m) {
		musicToMEvents:
		while (true) {
			switch (m.$) {
				case 0:
					if (!m.a.$) {
						var _n5 = m.a;
						var dur = _n5.a;
						var p = _n5.b;
						return _Utils_Tuple2(
							_List_fromArray(
								[
									A3(author$project$Mousikea$Midi$MEvent$noteToMEvent, ctx, dur, p)
								]),
							A2(author$project$Mousikea$Util$Ratio$mul, dur, ctx.aJ));
					} else {
						var dur = m.a.a;
						return _Utils_Tuple2(
							_List_Nil,
							A2(author$project$Mousikea$Util$Ratio$mul, dur, ctx.aJ));
					}
				case 1:
					var m1 = m.a;
					var m2 = m.b;
					var _n6 = A2(author$project$Mousikea$Midi$MEvent$musicToMEvents, ctx, m1);
					var evs1 = _n6.a;
					var d1 = _n6.b;
					var _n7 = A2(
						author$project$Mousikea$Midi$MEvent$musicToMEvents,
						_Utils_update(
							ctx,
							{
								aK: A2(author$project$Mousikea$Util$Ratio$add, ctx.aK, d1)
							}),
						m2);
					var evs2 = _n7.a;
					var d2 = _n7.b;
					return _Utils_Tuple2(
						_Utils_ap(evs1, evs2),
						A2(author$project$Mousikea$Util$Ratio$add, d1, d2));
				case 2:
					var m1 = m.a;
					var m2 = m.b;
					var _n8 = A2(author$project$Mousikea$Midi$MEvent$musicToMEvents, ctx, m2);
					var evs2 = _n8.a;
					var d2 = _n8.b;
					var _n9 = A2(author$project$Mousikea$Midi$MEvent$musicToMEvents, ctx, m1);
					var evs1 = _n9.a;
					var d1 = _n9.b;
					return _Utils_Tuple2(
						A2(author$project$Mousikea$Midi$MEvent$merge, evs1, evs2),
						A2(author$project$Mousikea$Util$Ratio$max, d1, d2));
				default:
					switch (m.a.$) {
						case 2:
							var i = m.a.a;
							var m_ = m.b;
							var $temp$ctx = _Utils_update(
								ctx,
								{bB: i}),
								$temp$m = m_;
							ctx = $temp$ctx;
							m = $temp$m;
							continue musicToMEvents;
						case 3:
							var pas = m.a.a;
							var m_ = m.b;
							return A3(author$project$Mousikea$Midi$MEvent$phraseToMEvents, ctx, pas, m_);
						case 4:
							var _n10 = m.a;
							var m_ = m.b;
							var $temp$ctx = ctx,
								$temp$m = m_;
							ctx = $temp$ctx;
							m = $temp$m;
							continue musicToMEvents;
						case 5:
							var m_ = m.b;
							var $temp$ctx = ctx,
								$temp$m = m_;
							ctx = $temp$ctx;
							m = $temp$m;
							continue musicToMEvents;
						default:
							var m_ = m.b;
							var $temp$ctx = ctx,
								$temp$m = author$project$Mousikea$Midi$MEvent$applyControls(m_);
							ctx = $temp$ctx;
							m = $temp$m;
							continue musicToMEvents;
					}
			}
		}
	});
var author$project$Mousikea$Midi$MEvent$phraseToMEvents = F3(
	function (ctx, pas, m) {
		phraseToMEvents:
		while (true) {
			if (!pas.b) {
				return A2(author$project$Mousikea$Midi$MEvent$musicToMEvents, ctx, m);
			} else {
				var h = pas.a;
				var t = pas.b;
				var loud = function (x) {
					return A3(
						author$project$Mousikea$Midi$MEvent$phraseToMEvents,
						ctx,
						A2(
							elm$core$List$cons,
							author$project$Mousikea$Music$Dyn(
								author$project$Mousikea$Music$Loudness(
									author$project$Mousikea$Util$Ratio$fromInt(x))),
							t),
						m);
				};
				var _n1 = A3(author$project$Mousikea$Midi$MEvent$phraseToMEvents, ctx, t, m);
				var pf = _n1.a;
				var dur = _n1.b;
				var inflate = function (x) {
					var t0 = A2(
						elm$core$Maybe$withDefault,
						author$project$Mousikea$Music$zero,
						A2(
							elm$core$Maybe$map,
							function ($) {
								return $.z;
							},
							elm$core$List$head(pf)));
					var r = A2(author$project$Mousikea$Util$Ratio$div, x, dur);
					var upd = function (ev) {
						return _Utils_update(
							ev,
							{
								S: author$project$Mousikea$Util$Ratio$round(
									A2(
										author$project$Mousikea$Util$Ratio$mul,
										A2(
											author$project$Mousikea$Util$Ratio$add,
											author$project$Mousikea$Util$Ratio$fromInt(1),
											A2(
												author$project$Mousikea$Util$Ratio$mul,
												A2(author$project$Mousikea$Util$Ratio$sub, ev.z, t0),
												r)),
										author$project$Mousikea$Util$Ratio$fromInt(ev.S)))
							});
					};
					return _Utils_Tuple2(
						A2(elm$core$List$map, upd, pf),
						dur);
				};
				var stretch = function (x) {
					var t0 = A2(
						elm$core$Maybe$withDefault,
						author$project$Mousikea$Music$zero,
						A2(
							elm$core$Maybe$map,
							function ($) {
								return $.z;
							},
							elm$core$List$head(pf)));
					var r = A2(author$project$Mousikea$Util$Ratio$div, x, dur);
					var upd = function (ev) {
						var dt = A2(author$project$Mousikea$Util$Ratio$sub, ev.z, t0);
						var t_ = A2(
							author$project$Mousikea$Util$Ratio$add,
							A2(
								author$project$Mousikea$Util$Ratio$mul,
								A2(
									author$project$Mousikea$Util$Ratio$add,
									author$project$Mousikea$Util$Ratio$fromInt(1),
									A2(author$project$Mousikea$Util$Ratio$mul, dt, r)),
								dt),
							t0);
						var d_ = A2(
							author$project$Mousikea$Util$Ratio$mul,
							A2(
								author$project$Mousikea$Util$Ratio$add,
								author$project$Mousikea$Util$Ratio$fromInt(1),
								A2(
									author$project$Mousikea$Util$Ratio$mul,
									A2(
										author$project$Mousikea$Util$Ratio$add,
										A2(
											author$project$Mousikea$Util$Ratio$mul,
											author$project$Mousikea$Util$Ratio$fromInt(2),
											dt),
										ev.y),
									r)),
							ev.y);
						return _Utils_update(
							ev,
							{y: d_, z: t_});
					};
					return _Utils_Tuple2(
						A2(elm$core$List$map, upd, pf),
						A2(
							author$project$Mousikea$Util$Ratio$mul,
							A2(
								author$project$Mousikea$Util$Ratio$add,
								author$project$Mousikea$Util$Ratio$fromInt(1),
								x),
							dur));
				};
				switch (h.$) {
					case 0:
						switch (h.a.$) {
							case 0:
								var x = h.a.a;
								return _Utils_Tuple2(
									A2(
										elm$core$List$map,
										function (e) {
											return _Utils_update(
												e,
												{
													S: author$project$Mousikea$Util$Ratio$round(
														A2(
															author$project$Mousikea$Util$Ratio$mul,
															x,
															author$project$Mousikea$Util$Ratio$fromInt(e.S)))
												});
										},
										pf),
									dur);
							case 3:
								var l = h.a.a;
								switch (l) {
									case 0:
										return loud(40);
									case 1:
										return loud(50);
									case 2:
										return loud(60);
									case 3:
										return loud(70);
									case 4:
										return loud(80);
									case 5:
										return loud(90);
									case 6:
										return loud(100);
									case 7:
										return loud(110);
									default:
										return loud(120);
								}
							case 4:
								var x = h.a.a;
								var $temp$ctx = _Utils_update(
									ctx,
									{
										bC: author$project$Mousikea$Util$Ratio$round(x)
									}),
									$temp$pas = t,
									$temp$m = m;
								ctx = $temp$ctx;
								pas = $temp$pas;
								m = $temp$m;
								continue phraseToMEvents;
							case 1:
								var x = h.a.a;
								return inflate(x);
							default:
								var x = h.a.a;
								return inflate(
									A2(
										author$project$Mousikea$Util$Ratio$mul,
										author$project$Mousikea$Util$Ratio$fromInt(-1),
										x));
						}
					case 1:
						if (!h.a.$) {
							var x = h.a.a;
							return stretch(x);
						} else {
							var x = h.a.a;
							return stretch(
								A2(
									author$project$Mousikea$Util$Ratio$mul,
									author$project$Mousikea$Util$Ratio$fromInt(-1),
									x));
						}
					case 2:
						switch (h.a.$) {
							case 0:
								var x = h.a.a;
								return _Utils_Tuple2(
									A2(
										elm$core$List$map,
										function (e) {
											return _Utils_update(
												e,
												{
													y: A2(author$project$Mousikea$Util$Ratio$mul, x, e.y)
												});
										},
										pf),
									dur);
							case 1:
								var x = h.a.a;
								return _Utils_Tuple2(
									A2(
										elm$core$List$map,
										function (e) {
											return _Utils_update(
												e,
												{
													y: A2(author$project$Mousikea$Util$Ratio$mul, x, e.y)
												});
										},
										pf),
									dur);
							case 2:
								var x = h.a.a;
								var lastStartTime = A3(
									elm$core$List$foldr,
									F2(
										function (e, acc) {
											return A2(author$project$Mousikea$Util$Ratio$max, e.z, acc);
										}),
									author$project$Mousikea$Music$zero,
									pf);
								var setDur = function (e) {
									return A2(author$project$Mousikea$Util$Ratio$lt, e.z, lastStartTime) ? _Utils_update(
										e,
										{
											y: A2(author$project$Mousikea$Util$Ratio$mul, x, e.y)
										}) : e;
								};
								return _Utils_Tuple2(
									A2(elm$core$List$map, setDur, pf),
									dur);
							default:
								return _Utils_Tuple2(pf, dur);
						}
					default:
						return _Utils_Tuple2(pf, dur);
				}
			}
		}
	});
var author$project$Mousikea$Music$AcousticGrandPiano = {$: 0};
var author$project$Mousikea$Util$Ratio$divideIntBy = F2(
	function (i, r) {
		return author$project$Mousikea$Util$Ratio$normalize(
			A2(
				author$project$Mousikea$Util$Ratio$divide,
				author$project$Mousikea$Util$Ratio$fromInt(i),
				r));
	});
var author$project$Mousikea$Util$Ratio$divIntBy = author$project$Mousikea$Util$Ratio$divideIntBy;
var author$project$Mousikea$Util$Ratio$multiplyByInt = F2(
	function (_n0, i) {
		var a = _n0.a;
		var b = _n0.b;
		return author$project$Mousikea$Util$Ratio$normalize(
			A2(author$project$Mousikea$Util$Ratio$Rational, a * i, b));
	});
var author$project$Mousikea$Util$Ratio$mulByInt = author$project$Mousikea$Util$Ratio$multiplyByInt;
var elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var author$project$Mousikea$Midi$MEvent$perform1Dur = function () {
	var metro = F2(
		function (setting, dur) {
			return A2(
				author$project$Mousikea$Util$Ratio$divIntBy,
				60,
				A2(author$project$Mousikea$Util$Ratio$mulByInt, dur, setting));
		});
	var defCon = {
		aJ: A2(metro, 120, author$project$Mousikea$Music$qn),
		bB: author$project$Mousikea$Music$AcousticGrandPiano,
		aK: author$project$Mousikea$Util$Ratio$fromInt(0),
		bC: 127
	};
	return A2(
		elm$core$Basics$composeL,
		author$project$Mousikea$Midi$MEvent$musicToMEvents(defCon),
		author$project$Mousikea$Midi$MEvent$applyControls);
}();
var elm$core$Tuple$first = function (_n0) {
	var x = _n0.a;
	return x;
};
var author$project$Mousikea$Midi$MEvent$perform1 = A2(elm$core$Basics$composeL, elm$core$Tuple$first, author$project$Mousikea$Midi$MEvent$perform1Dur);
var author$project$Mousikea$Midi$MEvent$performAbsPitchVol = A2(elm$core$Basics$composeL, author$project$Mousikea$Midi$MEvent$perform1, author$project$Mousikea$Music$fromAbsPitchVolume);
var author$project$Mousikea$Music$fromNote1 = elm$core$Basics$identity;
var author$project$Mousikea$Midi$MEvent$performNote1 = A2(elm$core$Basics$composeL, author$project$Mousikea$Midi$MEvent$perform1, author$project$Mousikea$Music$fromNote1);
var elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var elm$core$Dict$empty = elm$core$Dict$RBEmpty_elm_builtin;
var elm$core$Dict$Black = 1;
var elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var elm$core$Basics$compare = _Utils_compare;
var elm$core$Dict$Red = 0;
var elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _n1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _n3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5(elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5(elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _n5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _n6 = left.d;
				var _n7 = _n6.a;
				var llK = _n6.b;
				var llV = _n6.c;
				var llLeft = _n6.d;
				var llRight = _n6.e;
				var lRight = left.e;
				return A5(
					elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5(elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5(elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5(elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5(elm$core$Dict$RBNode_elm_builtin, 0, key, value, elm$core$Dict$RBEmpty_elm_builtin, elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _n1 = A2(elm$core$Basics$compare, key, nKey);
			switch (_n1) {
				case 0:
					return A5(
						elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3(elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5(elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3(elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _n0 = A3(elm$core$Dict$insertHelp, key, value, dict);
		if ((_n0.$ === -1) && (!_n0.a)) {
			var _n1 = _n0.a;
			var k = _n0.b;
			var v = _n0.c;
			var l = _n0.d;
			var r = _n0.e;
			return A5(elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _n0;
			return x;
		}
	});
var elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var elm$core$Array$branchFactor = 32;
var elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var elm$core$Basics$ceiling = _Basics_ceiling;
var elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var elm$core$Array$shiftStep = elm$core$Basics$ceiling(
	A2(elm$core$Basics$logBase, 2, elm$core$Array$branchFactor));
var elm$core$Elm$JsArray$empty = _JsArray_empty;
var elm$core$Array$empty = A4(elm$core$Array$Array_elm_builtin, 0, elm$core$Array$shiftStep, elm$core$Elm$JsArray$empty, elm$core$Elm$JsArray$empty);
var elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _n0 = A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodes);
			var node = _n0.a;
			var remainingNodes = _n0.b;
			var newAcc = A2(
				elm$core$List$cons,
				elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = elm$core$Basics$ceiling(nodeListSize / elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2(elm$core$Elm$JsArray$initializeFromList, elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2(elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var elm$core$Basics$floor = _Basics_floor;
var elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var elm$core$Elm$JsArray$length = _JsArray_length;
var elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.c) {
			return A4(
				elm$core$Array$Array_elm_builtin,
				elm$core$Elm$JsArray$length(builder.e),
				elm$core$Array$shiftStep,
				elm$core$Elm$JsArray$empty,
				builder.e);
		} else {
			var treeLen = builder.c * elm$core$Array$branchFactor;
			var depth = elm$core$Basics$floor(
				A2(elm$core$Basics$logBase, elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? elm$core$List$reverse(builder.f) : builder.f;
			var tree = A2(elm$core$Array$treeFromBuilder, correctNodeList, builder.c);
			return A4(
				elm$core$Array$Array_elm_builtin,
				elm$core$Elm$JsArray$length(builder.e) + treeLen,
				A2(elm$core$Basics$max, 5, depth * elm$core$Array$shiftStep),
				tree,
				builder.e);
		}
	});
var elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					elm$core$Array$builderToArray,
					false,
					{f: nodeList, c: (len / elm$core$Array$branchFactor) | 0, e: tail});
			} else {
				var leaf = elm$core$Array$Leaf(
					A3(elm$core$Elm$JsArray$initialize, elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2(elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return elm$core$Array$empty;
		} else {
			var tailLen = len % elm$core$Array$branchFactor;
			var tail = A3(elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - elm$core$Array$branchFactor;
			return A5(elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var elm$core$Basics$and = _Basics_and;
var elm$core$Char$toCode = _Char_toCode;
var elm$core$Char$isLower = function (_char) {
	var code = elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var elm$core$Char$isUpper = function (_char) {
	var code = elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var elm$core$Char$isAlpha = function (_char) {
	return elm$core$Char$isLower(_char) || elm$core$Char$isUpper(_char);
};
var elm$core$Char$isDigit = function (_char) {
	var code = elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var elm$core$Char$isAlphaNum = function (_char) {
	return elm$core$Char$isLower(_char) || (elm$core$Char$isUpper(_char) || elm$core$Char$isDigit(_char));
};
var elm$core$String$all = _String_all;
var elm$core$String$fromInt = _String_fromNumber;
var elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var elm$core$String$uncons = _String_uncons;
var elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var elm$json$Json$Decode$indent = function (str) {
	return A2(
		elm$core$String$join,
		'\n    ',
		A2(elm$core$String$split, '\n', str));
};
var elm$json$Json$Encode$encode = _Json_encode;
var elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + (elm$core$String$fromInt(i + 1) + (') ' + elm$json$Json$Decode$indent(
			elm$json$Json$Decode$errorToString(error))));
	});
var elm$json$Json$Decode$errorToString = function (error) {
	return A2(elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _n1 = elm$core$String$uncons(f);
						if (_n1.$ === 1) {
							return false;
						} else {
							var _n2 = _n1.a;
							var _char = _n2.a;
							var rest = _n2.b;
							return elm$core$Char$isAlpha(_char) && A2(elm$core$String$all, elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2(elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + (elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2(elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									elm$core$String$join,
									'',
									elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										elm$core$String$join,
										'',
										elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + (elm$core$String$fromInt(
								elm$core$List$length(errors)) + ' ways:'));
							return A2(
								elm$core$String$join,
								'\n\n',
								A2(
									elm$core$List$cons,
									introduction,
									A2(elm$core$List$indexedMap, elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								elm$core$String$join,
								'',
								elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + (elm$json$Json$Decode$indent(
						A2(elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var elm$core$Platform$Cmd$batch = _Platform_batch;
var elm$core$Platform$Cmd$none = elm$core$Platform$Cmd$batch(_List_Nil);
var author$project$Main$init = _Utils_Tuple2(
	{
		H: 'None playing...',
		bG: elm$core$Maybe$Nothing,
		aQ: elm$core$Maybe$Nothing,
		b7: A3(
			elm$core$Dict$insert,
			'7. Random Bossa',
			A2(elm$random$Random$map, author$project$Mousikea$Midi$MEvent$performNote1, author$project$Mousikea$Generator$bossa),
			A3(
				elm$core$Dict$insert,
				'6. Blue Bossa Jam',
				A2(elm$random$Random$map, author$project$Mousikea$Midi$MEvent$performNote1, author$project$Mousikea$Generator$blueBossa),
				A3(
					elm$core$Dict$insert,
					'5. Randomness with Tonality and Volume',
					A2(elm$random$Random$map, author$project$Mousikea$Midi$MEvent$performAbsPitchVol, author$project$Mousikea$Generator$randomness),
					elm$core$Dict$empty))),
		cg: A3(
			elm$core$Dict$insert,
			'3. Simple Disco Drum Beat',
			author$project$Mousikea$Midi$MEvent$performNote1(author$project$Mousikea$Examples$Drums$simpleBeat),
			A3(
				elm$core$Dict$insert,
				'0. Mine',
				author$project$Mousikea$Midi$MEvent$performNote1(author$project$Mousikea$Examples$Mine$music),
				elm$core$Dict$empty))
	},
	elm$core$Platform$Cmd$none);
var author$project$Main$MusicStarted = function (a) {
	return {$: 4, a: a};
};
var author$project$Main$MusicStopped = function (a) {
	return {$: 5, a: a};
};
var author$project$Main$TravisMessage = function (a) {
	return {$: 3, a: a};
};
var elm$json$Json$Decode$string = _Json_decodeString;
var author$project$Main$musicStarted = _Platform_incomingPort('musicStarted', elm$json$Json$Decode$string);
var author$project$Main$musicStopped = _Platform_incomingPort('musicStopped', elm$json$Json$Decode$string);
var author$project$Main$websocketIn = _Platform_incomingPort('websocketIn', elm$json$Json$Decode$string);
var elm$core$Platform$Sub$batch = _Platform_batch;
var author$project$Main$subscriptions = function (model) {
	return elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				author$project$Main$websocketIn(author$project$Main$TravisMessage),
				author$project$Main$musicStopped(author$project$Main$MusicStopped),
				author$project$Main$musicStarted(author$project$Main$MusicStarted)
			]));
};
var author$project$Main$Generated = function (a) {
	return {$: 2, a: a};
};
var author$project$Mousikea$Music$c = F2(
	function (octave, dur) {
		return A2(
			author$project$Mousikea$Music$note,
			dur,
			_Utils_Tuple2(2, octave));
	});
var author$project$Mousikea$Music$g = F2(
	function (octave, dur) {
		return A2(
			author$project$Mousikea$Music$note,
			dur,
			_Utils_Tuple2(22, octave));
	});
var author$project$Mousikea$Music$flip = function (fun) {
	return F2(
		function (y, x) {
			return A2(fun, x, y);
		});
};
var author$project$Mousikea$Music$fold = F5(
	function (func, onSeq, onPar, func2, m) {
		var rec = A4(author$project$Mousikea$Music$fold, func, onSeq, onPar, func2);
		switch (m.$) {
			case 0:
				var p = m.a;
				return func(p);
			case 1:
				var m1 = m.a;
				var m2 = m.b;
				return A2(
					onSeq,
					rec(m1),
					rec(m2));
			case 2:
				var m1 = m.a;
				var m2 = m.b;
				return A2(
					onPar,
					rec(m1),
					rec(m2));
			default:
				var control = m.a;
				var m_ = m.b;
				return A2(
					func2,
					control,
					rec(m_));
		}
	});
var author$project$Mousikea$Music$invertAt = function (pRef) {
	return author$project$Mousikea$Music$map(
		function (p) {
			return author$project$Mousikea$Music$pitch(
				(2 * author$project$Mousikea$Music$absPitch(pRef)) - author$project$Mousikea$Music$absPitch(p));
		});
};
var elm$core$Basics$always = F2(
	function (a, _n0) {
		return a;
	});
var author$project$Mousikea$Music$invert = function (m) {
	var pFun = function (m_) {
		if (!m_.$) {
			var p = m_.b;
			return _List_fromArray(
				[p]);
		} else {
			return _List_Nil;
		}
	};
	var pRef = A5(
		author$project$Mousikea$Music$fold,
		pFun,
		elm$core$Basics$append,
		elm$core$Basics$append,
		author$project$Mousikea$Music$flip(elm$core$Basics$always),
		m);
	if (!pRef.b) {
		return m;
	} else {
		var h = pRef.a;
		return A2(author$project$Mousikea$Music$invertAt, h, m);
	}
};
var author$project$Mousikea$Music$retro = function (m) {
	switch (m.$) {
		case 0:
			var x = m.a;
			return author$project$Mousikea$Music$Prim(x);
		case 3:
			var control = m.a;
			var m_ = m.b;
			return A2(
				author$project$Mousikea$Music$Modify,
				control,
				author$project$Mousikea$Music$retro(m_));
		case 1:
			var m1 = m.a;
			var m2 = m.b;
			return A2(
				author$project$Mousikea$Music$Seq,
				author$project$Mousikea$Music$retro(m2),
				author$project$Mousikea$Music$retro(m1));
		default:
			var m1 = m.a;
			var m2 = m.b;
			var d2 = author$project$Mousikea$Music$duration(m2);
			var d1 = author$project$Mousikea$Music$duration(m1);
			return A2(author$project$Mousikea$Util$Ratio$gt, d1, d2) ? A2(
				author$project$Mousikea$Music$Par,
				author$project$Mousikea$Music$retro(m1),
				A2(
					author$project$Mousikea$Music$Seq,
					author$project$Mousikea$Music$rest(
						A2(author$project$Mousikea$Util$Ratio$sub, d1, d2)),
					author$project$Mousikea$Music$retro(m2))) : A2(
				author$project$Mousikea$Music$Par,
				A2(
					author$project$Mousikea$Music$Seq,
					author$project$Mousikea$Music$rest(
						A2(author$project$Mousikea$Util$Ratio$sub, d2, d1)),
					author$project$Mousikea$Music$retro(m1)),
				author$project$Mousikea$Music$retro(m2));
	}
};
var author$project$Mousikea$Music$Transpose = function (a) {
	return {$: 1, a: a};
};
var author$project$Mousikea$Music$transpose = F2(
	function (i, m) {
		return A2(
			author$project$Mousikea$Music$Modify,
			author$project$Mousikea$Music$Transpose(i),
			m);
	});
var author$project$Mousikea$Examples$BlueLambda$blueLambda = function () {
	var x1 = author$project$Mousikea$Music$line(
		_List_fromArray(
			[
				A2(author$project$Mousikea$Music$c, 4, author$project$Mousikea$Music$en),
				A2(author$project$Mousikea$Music$g, 4, author$project$Mousikea$Music$en),
				A2(author$project$Mousikea$Music$c, 5, author$project$Mousikea$Music$en),
				A2(author$project$Mousikea$Music$g, 5, author$project$Mousikea$Music$en)
			]));
	var x2 = A2(
		author$project$Mousikea$Music$Seq,
		x1,
		A2(author$project$Mousikea$Music$transpose, 3, x1));
	var x3 = author$project$Mousikea$Music$line(
		_List_fromArray(
			[
				x2,
				x2,
				author$project$Mousikea$Music$invert(x2),
				author$project$Mousikea$Music$retro(x2)
			]));
	var x4 = A2(
		author$project$Mousikea$Music$Par,
		A2(author$project$Mousikea$Music$times, 6, x3),
		A2(
			author$project$Mousikea$Music$times,
			4,
			A2(
				author$project$Mousikea$Music$tempo,
				A2(author$project$Mousikea$Util$Ratio$over, 2, 3),
				x3)));
	return A2(
		author$project$Mousikea$Music$map,
		function (p) {
			return _Utils_Tuple2(
				p,
				_List_fromArray(
					[
						author$project$Mousikea$Music$Volume(60)
					]));
		},
		A2(author$project$Mousikea$Music$instrument, author$project$Mousikea$Music$RhodesPiano, x4));
}();
var author$project$Mousikea$Examples$ChildrenSong6$addDur = F2(
	function (dur, ns) {
		var f = function (n) {
			return n(dur);
		};
		return author$project$Mousikea$Music$line(
			A2(elm$core$List$map, f, ns));
	});
var author$project$Mousikea$Music$as_ = F2(
	function (octave, dur) {
		return A2(
			author$project$Mousikea$Music$note,
			dur,
			_Utils_Tuple2(29, octave));
	});
var author$project$Mousikea$Music$Es = 15;
var author$project$Mousikea$Music$es = F2(
	function (octave, dur) {
		return A2(
			author$project$Mousikea$Music$note,
			dur,
			_Utils_Tuple2(15, octave));
	});
var author$project$Mousikea$Music$fs = F2(
	function (octave, dur) {
		return A2(
			author$project$Mousikea$Music$note,
			dur,
			_Utils_Tuple2(19, octave));
	});
var author$project$Mousikea$Examples$ChildrenSong6$bassLine = function () {
	var b3 = A2(
		author$project$Mousikea$Examples$ChildrenSong6$addDur,
		author$project$Mousikea$Music$dqn,
		_List_fromArray(
			[
				author$project$Mousikea$Music$as_(2),
				author$project$Mousikea$Music$fs(3),
				author$project$Mousikea$Music$g(3),
				author$project$Mousikea$Music$fs(3)
			]));
	var b2 = A2(
		author$project$Mousikea$Examples$ChildrenSong6$addDur,
		author$project$Mousikea$Music$dqn,
		_List_fromArray(
			[
				author$project$Mousikea$Music$b(2),
				author$project$Mousikea$Music$es(3),
				author$project$Mousikea$Music$fs(3),
				author$project$Mousikea$Music$es(3)
			]));
	var b1 = A2(
		author$project$Mousikea$Examples$ChildrenSong6$addDur,
		author$project$Mousikea$Music$dqn,
		_List_fromArray(
			[
				author$project$Mousikea$Music$b(2),
				author$project$Mousikea$Music$fs(3),
				author$project$Mousikea$Music$g(3),
				author$project$Mousikea$Music$fs(3)
			]));
	return author$project$Mousikea$Music$line(
		_List_fromArray(
			[
				A2(author$project$Mousikea$Music$times, 3, b1),
				A2(author$project$Mousikea$Music$times, 2, b2),
				A2(author$project$Mousikea$Music$times, 4, b3),
				A2(author$project$Mousikea$Music$times, 5, b1)
			]));
}();
var author$project$Mousikea$Util$Ratio$divideByInt = F2(
	function (r, i) {
		return author$project$Mousikea$Util$Ratio$normalize(
			A2(
				author$project$Mousikea$Util$Ratio$divide,
				r,
				author$project$Mousikea$Util$Ratio$fromInt(i)));
	});
var author$project$Mousikea$Util$Ratio$divByInt = author$project$Mousikea$Util$Ratio$divideByInt;
var author$project$Mousikea$Examples$ChildrenSong6$graceNote = F2(
	function (n, m) {
		if ((!m.$) && (!m.a.$)) {
			var _n1 = m.a;
			var dur = _n1.a;
			var p = _n1.b;
			return A2(
				author$project$Mousikea$Music$Seq,
				A2(
					author$project$Mousikea$Music$note,
					A2(author$project$Mousikea$Util$Ratio$divByInt, dur, 8),
					A2(author$project$Mousikea$Music$trans, n, p)),
				A2(
					author$project$Mousikea$Music$note,
					A2(
						author$project$Mousikea$Util$Ratio$mulByInt,
						A2(author$project$Mousikea$Util$Ratio$divByInt, dur, 8),
						7),
					p));
		} else {
			return m;
		}
	});
var author$project$Mousikea$Music$cs = F2(
	function (octave, dur) {
		return A2(
			author$project$Mousikea$Music$note,
			dur,
			_Utils_Tuple2(4, octave));
	});
var author$project$Mousikea$Music$d = F2(
	function (octave, dur) {
		return A2(
			author$project$Mousikea$Music$note,
			dur,
			_Utils_Tuple2(7, octave));
	});
var author$project$Mousikea$Music$e_ = F2(
	function (octave, dur) {
		return A2(
			author$project$Mousikea$Music$note,
			dur,
			_Utils_Tuple2(13, octave));
	});
var author$project$Mousikea$Examples$ChildrenSong6$v1 = function () {
	var v1b = A2(
		author$project$Mousikea$Examples$ChildrenSong6$addDur,
		author$project$Mousikea$Music$en,
		_List_fromArray(
			[
				author$project$Mousikea$Music$cs(4),
				author$project$Mousikea$Music$b(3)
			]));
	var v1a = A2(
		author$project$Mousikea$Examples$ChildrenSong6$addDur,
		author$project$Mousikea$Music$en,
		_List_fromArray(
			[
				author$project$Mousikea$Music$a(4),
				author$project$Mousikea$Music$e_(4),
				author$project$Mousikea$Music$d(4),
				author$project$Mousikea$Music$fs(4),
				author$project$Mousikea$Music$cs(4),
				author$project$Mousikea$Music$b(3),
				author$project$Mousikea$Music$e_(4),
				author$project$Mousikea$Music$b(3)
			]));
	return author$project$Mousikea$Music$line(
		_List_fromArray(
			[
				v1a,
				A2(
				author$project$Mousikea$Examples$ChildrenSong6$graceNote,
				-1,
				A2(author$project$Mousikea$Music$d, 4, author$project$Mousikea$Music$qn)),
				v1b
			]));
}();
var author$project$Mousikea$Music$dhn = A2(author$project$Mousikea$Util$Ratio$over, 3, 4);
var author$project$Mousikea$Music$enr = author$project$Mousikea$Music$rest(author$project$Mousikea$Music$en);
var author$project$Mousikea$Music$f = F2(
	function (octave, dur) {
		return A2(
			author$project$Mousikea$Music$note,
			dur,
			_Utils_Tuple2(16, octave));
	});
var author$project$Mousikea$Music$gs = F2(
	function (octave, dur) {
		return A2(
			author$project$Mousikea$Music$note,
			dur,
			_Utils_Tuple2(24, octave));
	});
var author$project$Mousikea$Examples$ChildrenSong6$v2 = function () {
	var v2g = A2(
		author$project$Mousikea$Music$Seq,
		A2(
			author$project$Mousikea$Music$tempo,
			A2(author$project$Mousikea$Util$Ratio$over, 3, 2),
			author$project$Mousikea$Music$line(
				_List_fromArray(
					[
						A2(author$project$Mousikea$Music$cs, 4, author$project$Mousikea$Music$en),
						A2(author$project$Mousikea$Music$d, 4, author$project$Mousikea$Music$en),
						A2(author$project$Mousikea$Music$cs, 4, author$project$Mousikea$Music$en)
					]))),
		A2(
			author$project$Mousikea$Music$b,
			3,
			A2(
				author$project$Mousikea$Util$Ratio$add,
				A2(author$project$Mousikea$Util$Ratio$mulByInt, author$project$Mousikea$Music$dhn, 3),
				author$project$Mousikea$Music$hn)));
	var v2f = author$project$Mousikea$Music$line(
		_List_fromArray(
			[
				A2(author$project$Mousikea$Music$fs, 4, author$project$Mousikea$Music$en),
				A2(author$project$Mousikea$Music$a, 4, author$project$Mousikea$Music$en),
				A2(
				author$project$Mousikea$Music$b,
				4,
				A2(author$project$Mousikea$Util$Ratio$add, author$project$Mousikea$Music$hn, author$project$Mousikea$Music$qn)),
				A2(author$project$Mousikea$Music$a, 4, author$project$Mousikea$Music$en),
				A2(author$project$Mousikea$Music$fs, 4, author$project$Mousikea$Music$en),
				A2(author$project$Mousikea$Music$e_, 4, author$project$Mousikea$Music$qn),
				A2(author$project$Mousikea$Music$d, 4, author$project$Mousikea$Music$en),
				A2(author$project$Mousikea$Music$fs, 4, author$project$Mousikea$Music$en),
				A2(author$project$Mousikea$Music$e_, 4, author$project$Mousikea$Music$hn),
				A2(author$project$Mousikea$Music$d, 4, author$project$Mousikea$Music$hn),
				A2(author$project$Mousikea$Music$fs, 4, author$project$Mousikea$Music$qn)
			]));
	var v2e = author$project$Mousikea$Music$line(
		_List_fromArray(
			[
				A2(
				author$project$Mousikea$Examples$ChildrenSong6$graceNote,
				2,
				A2(author$project$Mousikea$Music$e_, 4, author$project$Mousikea$Music$qn)),
				A2(author$project$Mousikea$Music$d, 4, author$project$Mousikea$Music$en),
				A2(
				author$project$Mousikea$Examples$ChildrenSong6$graceNote,
				2,
				A2(author$project$Mousikea$Music$d, 4, author$project$Mousikea$Music$qn)),
				A2(author$project$Mousikea$Music$cs, 4, author$project$Mousikea$Music$en),
				A2(
				author$project$Mousikea$Examples$ChildrenSong6$graceNote,
				1,
				A2(author$project$Mousikea$Music$cs, 4, author$project$Mousikea$Music$qn)),
				A2(
				author$project$Mousikea$Music$b,
				3,
				A2(author$project$Mousikea$Util$Ratio$add, author$project$Mousikea$Music$en, author$project$Mousikea$Music$hn)),
				A2(author$project$Mousikea$Music$cs, 4, author$project$Mousikea$Music$en),
				A2(author$project$Mousikea$Music$b, 3, author$project$Mousikea$Music$en)
			]));
	var v2d = A2(
		author$project$Mousikea$Examples$ChildrenSong6$addDur,
		author$project$Mousikea$Music$en,
		_List_fromArray(
			[
				author$project$Mousikea$Music$fs(4),
				author$project$Mousikea$Music$cs(4),
				author$project$Mousikea$Music$e_(4),
				author$project$Mousikea$Music$cs(4),
				author$project$Mousikea$Music$a(3),
				author$project$Mousikea$Music$as_(3),
				author$project$Mousikea$Music$d(4),
				author$project$Mousikea$Music$e_(4),
				author$project$Mousikea$Music$fs(4)
			]));
	var v2c = author$project$Mousikea$Music$line(
		_List_fromArray(
			[
				author$project$Mousikea$Music$line(
				_List_fromArray(
					[
						A2(author$project$Mousikea$Music$g, 4, author$project$Mousikea$Music$en),
						A2(author$project$Mousikea$Music$as_, 4, author$project$Mousikea$Music$en),
						A2(
						author$project$Mousikea$Music$cs,
						5,
						A2(author$project$Mousikea$Util$Ratio$add, author$project$Mousikea$Music$hn, author$project$Mousikea$Music$en)),
						A2(author$project$Mousikea$Music$d, 5, author$project$Mousikea$Music$en),
						A2(author$project$Mousikea$Music$cs, 5, author$project$Mousikea$Music$en)
					])),
				A2(author$project$Mousikea$Music$e_, 4, author$project$Mousikea$Music$en),
				author$project$Mousikea$Music$enr,
				author$project$Mousikea$Music$line(
				_List_fromArray(
					[
						A2(author$project$Mousikea$Music$as_, 4, author$project$Mousikea$Music$en),
						A2(author$project$Mousikea$Music$a, 4, author$project$Mousikea$Music$en),
						A2(author$project$Mousikea$Music$g, 4, author$project$Mousikea$Music$en),
						A2(author$project$Mousikea$Music$d, 4, author$project$Mousikea$Music$qn),
						A2(author$project$Mousikea$Music$c, 4, author$project$Mousikea$Music$en),
						A2(author$project$Mousikea$Music$cs, 4, author$project$Mousikea$Music$en)
					]))
			]));
	var v2b = author$project$Mousikea$Music$line(
		_List_fromArray(
			[
				A2(
				author$project$Mousikea$Examples$ChildrenSong6$addDur,
				author$project$Mousikea$Music$en,
				_List_fromArray(
					[
						author$project$Mousikea$Music$fs(4),
						author$project$Mousikea$Music$e_(4),
						author$project$Mousikea$Music$cs(4),
						author$project$Mousikea$Music$as_(3)
					])),
				A2(author$project$Mousikea$Music$a, 3, author$project$Mousikea$Music$dqn),
				A2(
				author$project$Mousikea$Examples$ChildrenSong6$addDur,
				author$project$Mousikea$Music$en,
				_List_fromArray(
					[
						author$project$Mousikea$Music$as_(3),
						author$project$Mousikea$Music$cs(4),
						author$project$Mousikea$Music$fs(4),
						author$project$Mousikea$Music$e_(4),
						author$project$Mousikea$Music$fs(4)
					]))
			]));
	var v2a = author$project$Mousikea$Music$line(
		_List_fromArray(
			[
				A2(
				author$project$Mousikea$Music$cs,
				4,
				A2(author$project$Mousikea$Util$Ratio$add, author$project$Mousikea$Music$dhn, author$project$Mousikea$Music$dhn)),
				A2(author$project$Mousikea$Music$d, 4, author$project$Mousikea$Music$dhn),
				A2(author$project$Mousikea$Music$f, 4, author$project$Mousikea$Music$hn),
				A2(author$project$Mousikea$Music$gs, 4, author$project$Mousikea$Music$qn),
				A2(
				author$project$Mousikea$Music$fs,
				4,
				A2(author$project$Mousikea$Util$Ratio$add, author$project$Mousikea$Music$hn, author$project$Mousikea$Music$en)),
				A2(author$project$Mousikea$Music$g, 4, author$project$Mousikea$Music$en)
			]));
	return author$project$Mousikea$Music$line(
		_List_fromArray(
			[v2a, v2b, v2c, v2d, v2e, v2f, v2g]));
}();
var author$project$Mousikea$Examples$ChildrenSong6$mainVoice = A2(
	author$project$Mousikea$Music$Seq,
	A2(author$project$Mousikea$Music$times, 3, author$project$Mousikea$Examples$ChildrenSong6$v1),
	author$project$Mousikea$Examples$ChildrenSong6$v2);
var author$project$Mousikea$Examples$ChildrenSong6$childSong6 = function () {
	var t = A2(
		author$project$Mousikea$Util$Ratio$mul,
		A2(author$project$Mousikea$Util$Ratio$div, author$project$Mousikea$Music$dhn, author$project$Mousikea$Music$qn),
		A2(author$project$Mousikea$Util$Ratio$over, 69, 120));
	return A2(
		author$project$Mousikea$Music$map,
		function (p) {
			return _Utils_Tuple2(
				p,
				_List_fromArray(
					[
						author$project$Mousikea$Music$Volume(60)
					]));
		},
		A2(
			author$project$Mousikea$Music$instrument,
			author$project$Mousikea$Music$RhodesPiano,
			A2(
				author$project$Mousikea$Music$tempo,
				t,
				A2(author$project$Mousikea$Music$Par, author$project$Mousikea$Examples$ChildrenSong6$bassLine, author$project$Mousikea$Examples$ChildrenSong6$mainVoice))));
}();
var author$project$Mousikea$Examples$Mine$simpleBeat = A2(
	author$project$Mousikea$Music$map,
	function (p) {
		return _Utils_Tuple2(
			p,
			_List_fromArray(
				[
					author$project$Mousikea$Music$Volume(60)
				]));
	},
	A2(
		author$project$Mousikea$Music$times,
		16,
		A2(
			author$project$Mousikea$Music$Par,
			A2(
				author$project$Mousikea$Music$times,
				4,
				author$project$Mousikea$Music$line(
					_List_fromArray(
						[
							author$project$Mousikea$Music$rest(author$project$Mousikea$Music$qn),
							A2(
							author$project$Mousikea$Music$Par,
							A2(author$project$Mousikea$Music$perc, 3, author$project$Mousikea$Music$qn),
							A2(author$project$Mousikea$Music$perc, 4, author$project$Mousikea$Music$qn))
						]))),
			A2(
				author$project$Mousikea$Music$Par,
				A2(
					author$project$Mousikea$Music$times,
					8,
					A2(author$project$Mousikea$Music$perc, 7, author$project$Mousikea$Music$en)),
				A2(
					author$project$Mousikea$Music$times,
					4,
					A2(author$project$Mousikea$Music$perc, 0, author$project$Mousikea$Music$qn))))));
var author$project$Main$available = _List_fromArray(
	[author$project$Mousikea$Examples$Mine$simpleBeat, author$project$Mousikea$Examples$BlueLambda$blueLambda, author$project$Mousikea$Examples$ChildrenSong6$childSong6]);
var author$project$Main$TravisJob = F3(
	function (id, config, commit) {
		return {dd: commit, d8: config, ei: id};
	});
var author$project$Main$TravisJobCommit = F2(
	function (sha, message) {
		return {dz: message, et: sha};
	});
var elm$json$Json$Decode$field = _Json_decodeField;
var elm$json$Json$Decode$map2 = _Json_map2;
var author$project$Main$travisJobCommitDecoder = A3(
	elm$json$Json$Decode$map2,
	author$project$Main$TravisJobCommit,
	A2(elm$json$Json$Decode$field, 'sha', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'message', elm$json$Json$Decode$string));
var author$project$Main$TravisJobConfig = F2(
	function (os, language) {
		return {el: language, er: os};
	});
var author$project$Main$travisJobConfigDecoder = A3(
	elm$json$Json$Decode$map2,
	author$project$Main$TravisJobConfig,
	A2(elm$json$Json$Decode$field, 'os', elm$json$Json$Decode$string),
	A2(elm$json$Json$Decode$field, 'language', elm$json$Json$Decode$string));
var elm$json$Json$Decode$int = _Json_decodeInt;
var elm$json$Json$Decode$map3 = _Json_map3;
var author$project$Main$commitJobDecoder = A2(
	elm$json$Json$Decode$field,
	'job',
	A4(
		elm$json$Json$Decode$map3,
		author$project$Main$TravisJob,
		A2(elm$json$Json$Decode$field, 'id', elm$json$Json$Decode$int),
		A2(elm$json$Json$Decode$field, 'config', author$project$Main$travisJobConfigDecoder),
		A2(elm$json$Json$Decode$field, 'commit', author$project$Main$travisJobCommitDecoder)));
var author$project$Main$fallback = author$project$Mousikea$Examples$Mine$simpleBeat;
var author$project$Main$nonePlaying = 'None playing...';
var elm$json$Json$Encode$int = _Json_wrap;
var elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			elm$core$List$foldl,
			F2(
				function (_n0, obj) {
					var k = _n0.a;
					var v = _n0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var elm$json$Json$Encode$string = _Json_wrap;
var author$project$WebAudioFont$encodeInstrument = function (instrument) {
	if (!instrument.$) {
		var n = instrument.a;
		return elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					elm$json$Json$Encode$string('regular')),
					_Utils_Tuple2(
					'key',
					elm$json$Json$Encode$int(n))
				]));
	} else {
		var n = instrument.a;
		return elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'type',
					elm$json$Json$Encode$string('percussion')),
					_Utils_Tuple2(
					'key',
					elm$json$Json$Encode$int(n))
				]));
	}
};
var elm$json$Json$Encode$float = _Json_wrap;
var author$project$WebAudioFont$encodeEvent = function (_n0) {
	var time = _n0.c1;
	var instrument = _n0.aF;
	var pitch = _n0.cS;
	var duration = _n0.bo;
	var volume = _n0.c3;
	return elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'time',
				elm$json$Json$Encode$float(time)),
				_Utils_Tuple2(
				'instrument',
				author$project$WebAudioFont$encodeInstrument(instrument)),
				_Utils_Tuple2(
				'pitch',
				elm$json$Json$Encode$int(pitch)),
				_Utils_Tuple2(
				'duration',
				elm$json$Json$Encode$float(duration)),
				_Utils_Tuple2(
				'volume',
				elm$json$Json$Encode$float(volume))
			]));
};
var elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var author$project$WebAudioFont$encode = function (_n0) {
	var instruments = _n0.cJ;
	var events = _n0.cD;
	var drums = _n0.cA;
	return elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'instruments',
				A2(elm$json$Json$Encode$list, elm$json$Json$Encode$int, instruments)),
				_Utils_Tuple2(
				'events',
				A2(elm$json$Json$Encode$list, author$project$WebAudioFont$encodeEvent, events)),
				_Utils_Tuple2(
				'drums',
				A2(elm$json$Json$Encode$list, elm$json$Json$Encode$int, drums))
			]));
};
var author$project$WebAudioFont$Perc = function (a) {
	return {$: 1, a: a};
};
var author$project$WebAudioFont$Regular = function (a) {
	return {$: 0, a: a};
};
var author$project$WebAudioFont$toPercussionInstrumentNumber = function (pitch) {
	switch (pitch) {
		case 35:
			return 0;
		case 36:
			return 5;
		case 37:
			return 10;
		case 38:
			return 15;
		case 39:
			return 20;
		case 40:
			return 25;
		case 41:
			return 30;
		case 42:
			return 35;
		case 43:
			return 40;
		case 44:
			return 45;
		case 45:
			return 50;
		case 46:
			return 55;
		case 47:
			return 60;
		case 48:
			return 65;
		case 49:
			return 70;
		case 50:
			return 75;
		case 51:
			return 80;
		case 52:
			return 85;
		case 53:
			return 90;
		case 54:
			return 95;
		case 55:
			return 100;
		case 56:
			return 105;
		case 57:
			return 110;
		case 58:
			return 115;
		case 59:
			return 120;
		case 60:
			return 125;
		case 61:
			return 130;
		case 62:
			return 135;
		case 63:
			return 140;
		case 64:
			return 145;
		case 65:
			return 150;
		case 66:
			return 155;
		case 67:
			return 160;
		case 68:
			return 165;
		case 69:
			return 170;
		case 70:
			return 175;
		case 71:
			return 180;
		case 72:
			return 185;
		case 73:
			return 190;
		case 74:
			return 195;
		case 75:
			return 200;
		case 76:
			return 205;
		case 77:
			return 210;
		case 78:
			return 215;
		case 79:
			return 220;
		case 80:
			return 225;
		case 81:
			return 230;
		default:
			return 0;
	}
};
var author$project$WebAudioFont$toInstrumentNumber = F2(
	function (instrument, pitch) {
		switch (instrument.$) {
			case 0:
				return 0;
			case 1:
				return 11;
			case 2:
				return 22;
			case 3:
				return 32;
			case 4:
				return 45;
			case 5:
				return 58;
			case 6:
				return 70;
			case 7:
				return 81;
			case 8:
				return 89;
			case 9:
				return 99;
			case 10:
				return 107;
			case 11:
				return 116;
			case 12:
				return 124;
			case 13:
				return 133;
			case 14:
				return 141;
			case 15:
				return 152;
			case 16:
				return 160;
			case 17:
				return 170;
			case 18:
				return 180;
			case 19:
				return 190;
			case 20:
				return 200;
			case 21:
				return 211;
			case 22:
				return 223;
			case 23:
				return 231;
			case 24:
				return 244;
			case 25:
				return 256;
			case 26:
				return 274;
			case 27:
				return 286;
			case 28:
				return 299;
			case 29:
				return 315;
			case 30:
				return 333;
			case 31:
				return 354;
			case 32:
				return 366;
			case 33:
				return 375;
			case 34:
				return 384;
			case 35:
				return 393;
			case 36:
				return 401;
			case 37:
				return 409;
			case 38:
				return 418;
			case 39:
				return 434;
			case 40:
				return 447;
			case 41:
				return 458;
			case 42:
				return 466;
			case 43:
				return 475;
			case 44:
				return 483;
			case 45:
				return 492;
			case 46:
				return 500;
			case 47:
				return 508;
			case 48:
				return 517;
			case 49:
				return 544;
			case 50:
				return 553;
			case 51:
				return 567;
			case 52:
				return 576;
			case 53:
				return 588;
			case 54:
				return 600;
			case 55:
				return 608;
			case 56:
				return 617;
			case 57:
				return 624;
			case 58:
				return 632;
			case 59:
				return 640;
			case 60:
				return 648;
			case 61:
				return 659;
			case 62:
				return 671;
			case 63:
				return 683;
			case 64:
				return 695;
			case 65:
				return 703;
			case 66:
				return 712;
			case 67:
				return 721;
			case 68:
				return 729;
			case 69:
				return 737;
			case 70:
				return 745;
			case 71:
				return 754;
			case 72:
				return 762;
			case 73:
				return 771;
			case 74:
				return 781;
			case 75:
				return 789;
			case 76:
				return 800;
			case 77:
				return 811;
			case 78:
				return 821;
			case 79:
				return 829;
			case 80:
				return 837;
			case 81:
				return 846;
			case 82:
				return 856;
			case 83:
				return 868;
			case 84:
				return 878;
			case 85:
				return 892;
			case 86:
				return 903;
			case 87:
				return 913;
			case 88:
				return 923;
			case 89:
				return 944;
			case 90:
				return 954;
			case 91:
				return 965;
			case 92:
				return 976;
			case 93:
				return 986;
			case 94:
				return 997;
			case 95:
				return 1008;
			case 96:
				return 1017;
			case 97:
				return 1029;
			case 98:
				return 1039;
			case 99:
				return 1053;
			case 100:
				return 1069;
			case 101:
				return 1084;
			case 102:
				return 1095;
			case 103:
				return 1108;
			case 104:
				return 1120;
			case 105:
				return 1129;
			case 106:
				return 1137;
			case 107:
				return 1147;
			case 108:
				return 1158;
			case 109:
				return 1166;
			case 110:
				return 1174;
			case 111:
				return 1185;
			case 112:
				return 1192;
			case 113:
				return 1200;
			case 114:
				return 1209;
			case 115:
				return 1217;
			case 116:
				return 1228;
			case 117:
				return 1241;
			case 118:
				return 1252;
			case 119:
				return 1262;
			case 120:
				return 1273;
			case 121:
				return 1283;
			case 122:
				return 1293;
			case 123:
				return 1311;
			case 124:
				return 1324;
			case 125:
				return 1339;
			case 126:
				return 1365;
			case 127:
				return 1382;
			case 128:
				return author$project$WebAudioFont$toPercussionInstrumentNumber(pitch);
			default:
				return 0;
		}
	});
var author$project$WebAudioFont$fromMEvent = function (_n0) {
	var eTime = _n0.z;
	var eInst = _n0.dg;
	var ePitch = _n0.dh;
	var eDur = _n0.y;
	var eVol = _n0.S;
	return {
		bo: author$project$Mousikea$Util$Ratio$toFloat(eDur),
		aF: function () {
			if (eInst.$ === 128) {
				return author$project$WebAudioFont$Perc(
					A2(author$project$WebAudioFont$toInstrumentNumber, eInst, ePitch) + 0);
			} else {
				return author$project$WebAudioFont$Regular(
					A2(author$project$WebAudioFont$toInstrumentNumber, eInst, ePitch));
			}
		}(),
		cS: ePitch,
		c1: author$project$Mousikea$Util$Ratio$toFloat(eTime),
		c3: eVol / 127
	};
};
var elm$core$Set$Set_elm_builtin = elm$core$Basics$identity;
var elm$core$Set$empty = elm$core$Dict$empty;
var elm$core$Set$insert = F2(
	function (key, _n0) {
		var dict = _n0;
		return A3(elm$core$Dict$insert, key, 0, dict);
	});
var elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _n1 = A2(elm$core$Basics$compare, targetKey, key);
				switch (_n1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var elm$core$Dict$member = F2(
	function (key, dict) {
		var _n0 = A2(elm$core$Dict$get, key, dict);
		if (!_n0.$) {
			return true;
		} else {
			return false;
		}
	});
var elm$core$Set$member = F2(
	function (key, _n0) {
		var dict = _n0;
		return A2(elm$core$Dict$member, key, dict);
	});
var elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2(elm$core$Set$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2(elm$core$Set$insert, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2(elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var elm_community$list_extra$List$Extra$unique = function (list) {
	return A4(elm_community$list_extra$List$Extra$uniqueHelp, elm$core$Basics$identity, elm$core$Set$empty, list, _List_Nil);
};
var author$project$WebAudioFont$fromPerformance = function (performance) {
	var regular = function (instr) {
		if (!instr.$) {
			var n = instr.a;
			return _List_fromArray(
				[n]);
		} else {
			return _List_Nil;
		}
	};
	var perc = function (instr) {
		if (instr.$ === 1) {
			var n = instr.a;
			return _List_fromArray(
				[n]);
		} else {
			return _List_Nil;
		}
	};
	var events = A2(elm$core$List$map, author$project$WebAudioFont$fromMEvent, performance);
	return {
		cA: elm_community$list_extra$List$Extra$unique(
			A2(
				elm$core$List$concatMap,
				A2(
					elm$core$Basics$composeR,
					function ($) {
						return $.aF;
					},
					perc),
				events)),
		cD: events,
		cJ: elm_community$list_extra$List$Extra$unique(
			A2(
				elm$core$List$concatMap,
				A2(
					elm$core$Basics$composeR,
					function ($) {
						return $.aF;
					},
					regular),
				events))
	};
};
var author$project$WebAudioFont$play = _Platform_outgoingPort('play', elm$core$Basics$identity);
var author$project$WebAudioFont$queueWavTable = A2(
	elm$core$Basics$composeR,
	author$project$WebAudioFont$fromPerformance,
	A2(elm$core$Basics$composeR, author$project$WebAudioFont$encode, author$project$WebAudioFont$play));
var elm$json$Json$Encode$null = _Json_encodeNull;
var author$project$WebAudioFont$stop = _Platform_outgoingPort(
	'stop',
	function ($) {
		return elm$json$Json$Encode$null;
	});
var elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return elm$core$Result$Err(e);
		}
	});
var elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var elm$json$Json$Decode$decodeString = _Json_runOnString;
var elm$random$Random$Generate = elm$core$Basics$identity;
var elm$core$Task$andThen = _Scheduler_andThen;
var elm$core$Task$succeed = _Scheduler_succeed;
var elm$random$Random$initialSeed = function (x) {
	var _n0 = elm$random$Random$next(
		A2(elm$random$Random$Seed, 0, 1013904223));
	var state1 = _n0.a;
	var incr = _n0.b;
	var state2 = (state1 + x) >>> 0;
	return elm$random$Random$next(
		A2(elm$random$Random$Seed, state2, incr));
};
var elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var elm$time$Time$customZone = elm$time$Time$Zone;
var elm$time$Time$Posix = elm$core$Basics$identity;
var elm$time$Time$millisToPosix = elm$core$Basics$identity;
var elm$time$Time$now = _Time_now(elm$time$Time$millisToPosix);
var elm$time$Time$posixToMillis = function (_n0) {
	var millis = _n0;
	return millis;
};
var elm$random$Random$init = A2(
	elm$core$Task$andThen,
	function (time) {
		return elm$core$Task$succeed(
			elm$random$Random$initialSeed(
				elm$time$Time$posixToMillis(time)));
	},
	elm$time$Time$now);
var elm$core$Platform$sendToApp = _Platform_sendToApp;
var elm$random$Random$step = F2(
	function (_n0, seed) {
		var generator = _n0;
		return generator(seed);
	});
var elm$random$Random$onEffects = F3(
	function (router, commands, seed) {
		if (!commands.b) {
			return elm$core$Task$succeed(seed);
		} else {
			var generator = commands.a;
			var rest = commands.b;
			var _n1 = A2(elm$random$Random$step, generator, seed);
			var value = _n1.a;
			var newSeed = _n1.b;
			return A2(
				elm$core$Task$andThen,
				function (_n2) {
					return A3(elm$random$Random$onEffects, router, rest, newSeed);
				},
				A2(elm$core$Platform$sendToApp, router, value));
		}
	});
var elm$random$Random$onSelfMsg = F3(
	function (_n0, _n1, seed) {
		return elm$core$Task$succeed(seed);
	});
var elm$random$Random$cmdMap = F2(
	function (func, _n0) {
		var generator = _n0;
		return A2(elm$random$Random$map, func, generator);
	});
_Platform_effectManagers['Random'] = _Platform_createManager(elm$random$Random$init, elm$random$Random$onEffects, elm$random$Random$onSelfMsg, elm$random$Random$cmdMap);
var elm$random$Random$command = _Platform_leaf('Random');
var elm$random$Random$generate = F2(
	function (tagger, generator) {
		return elm$random$Random$command(
			A2(elm$random$Random$map, tagger, generator));
	});
var author$project$Main$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var key = msg.a;
				var found = A2(
					elm$core$Maybe$map,
					author$project$WebAudioFont$queueWavTable,
					A2(elm$core$Dict$get, key, model.cg));
				var nextModel = _Utils_update(
					model,
					{
						H: A2(
							elm$core$Maybe$withDefault,
							author$project$Main$nonePlaying,
							A2(
								elm$core$Maybe$map,
								function (m) {
									return 'Currently playing: ' + key;
								},
								found))
					});
				return _Utils_Tuple2(
					nextModel,
					A2(elm$core$Maybe$withDefault, elm$core$Platform$Cmd$none, found));
			case 6:
				var nextModel = _Utils_update(
					model,
					{H: author$project$Main$nonePlaying});
				var nextCmd = elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							author$project$WebAudioFont$stop(0)
						]));
				return _Utils_Tuple2(nextModel, nextCmd);
			case 1:
				var key = msg.a;
				var found = A2(elm$core$Dict$get, key, model.b7);
				return _Utils_Tuple2(
					model,
					A2(
						elm$core$Maybe$withDefault,
						elm$core$Platform$Cmd$none,
						A2(
							elm$core$Maybe$map,
							elm$random$Random$generate(author$project$Main$Generated),
							found)));
			case 2:
				var performance = msg.a;
				return _Utils_Tuple2(
					model,
					author$project$WebAudioFont$queueWavTable(performance));
			case 3:
				var message = msg.a;
				var job = A2(elm$json$Json$Decode$decodeString, author$project$Main$commitJobDecoder, message);
				var nextMessage = A2(
					elm$core$Result$withDefault,
					model.H,
					A2(
						elm$core$Result$map,
						function (j) {
							return j.dd.dz;
						},
						job));
				var music = A2(
					elm$core$Maybe$withDefault,
					author$project$Main$fallback,
					function (i) {
						return A2(elm_community$list_extra$List$Extra$getAt, i, author$project$Main$available);
					}(
						A2(
							elm$core$Basics$modBy,
							elm$core$List$length(author$project$Main$available),
							A2(
								elm$core$Maybe$withDefault,
								0,
								A2(
									elm$core$Maybe$map,
									function (_n3) {
										var c = _n3.a;
										var rest = _n3.b;
										return elm$core$Char$toCode(c);
									},
									elm$core$String$uncons(nextMessage))))));
				var perf = author$project$Mousikea$Midi$MEvent$performNote1(music);
				var _n1 = function () {
					var _n2 = model.aQ;
					if (_n2.$ === 1) {
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									H: nextMessage,
									bG: elm$core$Maybe$Nothing,
									aQ: elm$core$Maybe$Just(perf)
								}),
							author$project$WebAudioFont$queueWavTable(perf));
					} else {
						var p = _n2.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									H: nextMessage,
									bG: elm$core$Maybe$Just(p)
								}),
							elm$core$Platform$Cmd$none);
					}
				}();
				var nextModel = _n1.a;
				var cmd = _n1.b;
				return _Utils_Tuple2(nextModel, cmd);
			case 4:
				var str = msg.a;
				return function (d) {
					return _Utils_Tuple2(model, elm$core$Platform$Cmd$none);
				}(str);
			default:
				var str = msg.a;
				var nextModel = _Utils_update(
					model,
					{aQ: elm$core$Maybe$Nothing});
				return function (d) {
					return _Utils_Tuple2(nextModel, elm$core$Platform$Cmd$none);
				}(str);
		}
	});
var author$project$Main$Generate = function (a) {
	return {$: 1, a: a};
};
var author$project$Main$Play = function (a) {
	return {$: 0, a: a};
};
var author$project$Main$Stop = {$: 6};
var elm$json$Json$Decode$map = _Json_map1;
var elm$json$Json$Decode$succeed = _Json_succeed;
var elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var elm$html$Html$div = _VirtualDom_node('div');
var elm$html$Html$h3 = _VirtualDom_node('h3');
var elm$html$Html$i = _VirtualDom_node('i');
var elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var elm$html$Html$text = elm$virtual_dom$VirtualDom$text;
var elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			elm$json$Json$Encode$string(string));
	});
var elm$html$Html$Attributes$class = elm$html$Html$Attributes$stringProperty('className');
var rundis$elm_bootstrap$Bootstrap$Internal$Button$Attrs = function (a) {
	return {$: 4, a: a};
};
var rundis$elm_bootstrap$Bootstrap$Button$attrs = function (attrs_) {
	return rundis$elm_bootstrap$Bootstrap$Internal$Button$Attrs(attrs_);
};
var elm$html$Html$button = _VirtualDom_node('button');
var elm$core$Tuple$second = function (_n0) {
	var y = _n0.b;
	return y;
};
var elm$html$Html$Attributes$classList = function (classes) {
	return elm$html$Html$Attributes$class(
		A2(
			elm$core$String$join,
			' ',
			A2(
				elm$core$List$map,
				elm$core$Tuple$first,
				A2(elm$core$List$filter, elm$core$Tuple$second, classes))));
};
var elm$json$Json$Encode$bool = _Json_wrap;
var elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			elm$json$Json$Encode$bool(bool));
	});
var elm$html$Html$Attributes$disabled = elm$html$Html$Attributes$boolProperty('disabled');
var rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption = function (size) {
	switch (size) {
		case 0:
			return elm$core$Maybe$Nothing;
		case 1:
			return elm$core$Maybe$Just('sm');
		case 2:
			return elm$core$Maybe$Just('md');
		case 3:
			return elm$core$Maybe$Just('lg');
		default:
			return elm$core$Maybe$Just('xl');
	}
};
var rundis$elm_bootstrap$Bootstrap$Internal$Button$applyModifier = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 0:
				var size = modifier.a;
				return _Utils_update(
					options,
					{
						ce: elm$core$Maybe$Just(size)
					});
			case 1:
				var coloring = modifier.a;
				return _Utils_update(
					options,
					{
						G: elm$core$Maybe$Just(coloring)
					});
			case 2:
				return _Utils_update(
					options,
					{bd: true});
			case 3:
				var val = modifier.a;
				return _Utils_update(
					options,
					{bm: val});
			default:
				var attrs = modifier.a;
				return _Utils_update(
					options,
					{
						bb: _Utils_ap(options.bb, attrs)
					});
		}
	});
var rundis$elm_bootstrap$Bootstrap$Internal$Button$defaultOptions = {bb: _List_Nil, bd: false, G: elm$core$Maybe$Nothing, bm: false, ce: elm$core$Maybe$Nothing};
var rundis$elm_bootstrap$Bootstrap$Internal$Button$roleClass = function (role) {
	switch (role) {
		case 0:
			return 'primary';
		case 1:
			return 'secondary';
		case 2:
			return 'success';
		case 3:
			return 'info';
		case 4:
			return 'warning';
		case 5:
			return 'danger';
		case 6:
			return 'dark';
		case 7:
			return 'light';
		default:
			return 'link';
	}
};
var rundis$elm_bootstrap$Bootstrap$Internal$Button$buttonAttributes = function (modifiers) {
	var options = A3(elm$core$List$foldl, rundis$elm_bootstrap$Bootstrap$Internal$Button$applyModifier, rundis$elm_bootstrap$Bootstrap$Internal$Button$defaultOptions, modifiers);
	return _Utils_ap(
		_List_fromArray(
			[
				elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('btn', true),
						_Utils_Tuple2('btn-block', options.bd),
						_Utils_Tuple2('disabled', options.bm)
					])),
				elm$html$Html$Attributes$disabled(options.bm)
			]),
		_Utils_ap(
			function () {
				var _n0 = A2(elm$core$Maybe$andThen, rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption, options.ce);
				if (!_n0.$) {
					var s = _n0.a;
					return _List_fromArray(
						[
							elm$html$Html$Attributes$class('btn-' + s)
						]);
				} else {
					return _List_Nil;
				}
			}(),
			_Utils_ap(
				function () {
					var _n1 = options.G;
					if (!_n1.$) {
						if (!_n1.a.$) {
							var role = _n1.a.a;
							return _List_fromArray(
								[
									elm$html$Html$Attributes$class(
									'btn-' + rundis$elm_bootstrap$Bootstrap$Internal$Button$roleClass(role))
								]);
						} else {
							var role = _n1.a.a;
							return _List_fromArray(
								[
									elm$html$Html$Attributes$class(
									'btn-outline-' + rundis$elm_bootstrap$Bootstrap$Internal$Button$roleClass(role))
								]);
						}
					} else {
						return _List_Nil;
					}
				}(),
				options.bb)));
};
var rundis$elm_bootstrap$Bootstrap$Button$button = F2(
	function (options, children) {
		return A2(
			elm$html$Html$button,
			rundis$elm_bootstrap$Bootstrap$Internal$Button$buttonAttributes(options),
			children);
	});
var elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			elm$virtual_dom$VirtualDom$on,
			event,
			elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var rundis$elm_bootstrap$Bootstrap$Button$onClick = function (message) {
	return rundis$elm_bootstrap$Bootstrap$Button$attrs(
		_List_fromArray(
			[
				A2(
				elm$html$Html$Events$preventDefaultOn,
				'click',
				elm$json$Json$Decode$succeed(
					_Utils_Tuple2(message, true)))
			]));
};
var rundis$elm_bootstrap$Bootstrap$Internal$Button$Coloring = function (a) {
	return {$: 1, a: a};
};
var rundis$elm_bootstrap$Bootstrap$Internal$Button$Primary = 0;
var rundis$elm_bootstrap$Bootstrap$Internal$Button$Roled = function (a) {
	return {$: 0, a: a};
};
var rundis$elm_bootstrap$Bootstrap$Button$primary = rundis$elm_bootstrap$Bootstrap$Internal$Button$Coloring(
	rundis$elm_bootstrap$Bootstrap$Internal$Button$Roled(0));
var rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$ml2 = elm$html$Html$Attributes$class('ml-2');
var rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$mt5 = elm$html$Html$Attributes$class('mt-5');
var author$project$Main$viewSong = F2(
	function (msg, key) {
		return A2(
			elm$html$Html$div,
			_List_fromArray(
				[rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$mt5]),
			_List_fromArray(
				[
					A2(
					elm$html$Html$h3,
					_List_fromArray(
						[rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$mt5]),
					_List_fromArray(
						[
							elm$html$Html$text(key)
						])),
					A2(
					rundis$elm_bootstrap$Bootstrap$Button$button,
					_List_fromArray(
						[
							rundis$elm_bootstrap$Bootstrap$Button$primary,
							rundis$elm_bootstrap$Bootstrap$Button$onClick(
							msg(key))
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$i,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('fas fa-play')
								]),
							_List_Nil)
						])),
					A2(
					rundis$elm_bootstrap$Bootstrap$Button$button,
					_List_fromArray(
						[
							rundis$elm_bootstrap$Bootstrap$Button$attrs(
							_List_fromArray(
								[rundis$elm_bootstrap$Bootstrap$Utilities$Spacing$ml2])),
							rundis$elm_bootstrap$Bootstrap$Button$primary,
							rundis$elm_bootstrap$Bootstrap$Button$onClick(author$project$Main$Stop)
						]),
					_List_fromArray(
						[
							A2(
							elm$html$Html$i,
							_List_fromArray(
								[
									elm$html$Html$Attributes$class('fas fa-stop')
								]),
							_List_Nil)
						]))
				]));
	});
var elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var elm$html$Html$Attributes$style = elm$virtual_dom$VirtualDom$style;
var elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var elm$html$Html$node = elm$virtual_dom$VirtualDom$node;
var elm$html$Html$Attributes$href = function (url) {
	return A2(
		elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var elm$html$Html$Attributes$rel = _VirtualDom_attribute('rel');
var rundis$elm_bootstrap$Bootstrap$CDN$stylesheet = A3(
	elm$html$Html$node,
	'link',
	_List_fromArray(
		[
			elm$html$Html$Attributes$rel('stylesheet'),
			elm$html$Html$Attributes$href('https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css')
		]),
	_List_Nil);
var rundis$elm_bootstrap$Bootstrap$Grid$Column = function (a) {
	return {$: 0, a: a};
};
var rundis$elm_bootstrap$Bootstrap$Grid$col = F2(
	function (options, children) {
		return rundis$elm_bootstrap$Bootstrap$Grid$Column(
			{da: children, cP: options});
	});
var rundis$elm_bootstrap$Bootstrap$Grid$container = F2(
	function (attributes, children) {
		return A2(
			elm$html$Html$div,
			_Utils_ap(
				_List_fromArray(
					[
						elm$html$Html$Attributes$class('container')
					]),
				attributes),
			children);
	});
var elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var elm$html$Html$Keyed$node = elm$virtual_dom$VirtualDom$keyedNode;
var rundis$elm_bootstrap$Bootstrap$General$Internal$XS = 0;
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$Col = 0;
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$Width = F2(
	function (screenSize, columnCount) {
		return {db: columnCount, dT: screenSize};
	});
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColAlign = F2(
	function (align_, options) {
		var _n0 = align_.dT;
		switch (_n0) {
			case 0:
				return _Utils_update(
					options,
					{
						a8: elm$core$Maybe$Just(align_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						a6: elm$core$Maybe$Just(align_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						a5: elm$core$Maybe$Just(align_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						a4: elm$core$Maybe$Just(align_)
					});
			default:
				return _Utils_update(
					options,
					{
						a7: elm$core$Maybe$Just(align_)
					});
		}
	});
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColOffset = F2(
	function (offset_, options) {
		var _n0 = offset_.dT;
		switch (_n0) {
			case 0:
				return _Utils_update(
					options,
					{
						bM: elm$core$Maybe$Just(offset_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						bJ: elm$core$Maybe$Just(offset_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						bI: elm$core$Maybe$Just(offset_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						bH: elm$core$Maybe$Just(offset_)
					});
			default:
				return _Utils_update(
					options,
					{
						bL: elm$core$Maybe$Just(offset_)
					});
		}
	});
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColOrder = F2(
	function (order_, options) {
		var _n0 = order_.dT;
		switch (_n0) {
			case 0:
				return _Utils_update(
					options,
					{
						bW: elm$core$Maybe$Just(order_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						bU: elm$core$Maybe$Just(order_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						bT: elm$core$Maybe$Just(order_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						bS: elm$core$Maybe$Just(order_)
					});
			default:
				return _Utils_update(
					options,
					{
						bV: elm$core$Maybe$Just(order_)
					});
		}
	});
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColPull = F2(
	function (pull_, options) {
		var _n0 = pull_.dT;
		switch (_n0) {
			case 0:
				return _Utils_update(
					options,
					{
						b1: elm$core$Maybe$Just(pull_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						b$: elm$core$Maybe$Just(pull_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						b_: elm$core$Maybe$Just(pull_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						bZ: elm$core$Maybe$Just(pull_)
					});
			default:
				return _Utils_update(
					options,
					{
						b0: elm$core$Maybe$Just(pull_)
					});
		}
	});
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColPush = F2(
	function (push_, options) {
		var _n0 = push_.dT;
		switch (_n0) {
			case 0:
				return _Utils_update(
					options,
					{
						b6: elm$core$Maybe$Just(push_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						b4: elm$core$Maybe$Just(push_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						b3: elm$core$Maybe$Just(push_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						b2: elm$core$Maybe$Just(push_)
					});
			default:
				return _Utils_update(
					options,
					{
						b5: elm$core$Maybe$Just(push_)
					});
		}
	});
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColWidth = F2(
	function (width_, options) {
		var _n0 = width_.dT;
		switch (_n0) {
			case 0:
				return _Utils_update(
					options,
					{
						a$: elm$core$Maybe$Just(width_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						aZ: elm$core$Maybe$Just(width_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						aY: elm$core$Maybe$Just(width_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						aX: elm$core$Maybe$Just(width_)
					});
			default:
				return _Utils_update(
					options,
					{
						a_: elm$core$Maybe$Just(width_)
					});
		}
	});
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColOption = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 6:
				var attrs = modifier.a;
				return _Utils_update(
					options,
					{
						bb: _Utils_ap(options.bb, attrs)
					});
			case 0:
				var width_ = modifier.a;
				return A2(rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColWidth, width_, options);
			case 1:
				var offset_ = modifier.a;
				return A2(rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColOffset, offset_, options);
			case 2:
				var pull_ = modifier.a;
				return A2(rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColPull, pull_, options);
			case 3:
				var push_ = modifier.a;
				return A2(rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColPush, push_, options);
			case 4:
				var order_ = modifier.a;
				return A2(rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColOrder, order_, options);
			case 5:
				var align = modifier.a;
				return A2(rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColAlign, align, options);
			default:
				var align = modifier.a;
				return _Utils_update(
					options,
					{
						ch: elm$core$Maybe$Just(align)
					});
		}
	});
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$columnCountOption = function (size) {
	switch (size) {
		case 0:
			return elm$core$Maybe$Nothing;
		case 1:
			return elm$core$Maybe$Just('1');
		case 2:
			return elm$core$Maybe$Just('2');
		case 3:
			return elm$core$Maybe$Just('3');
		case 4:
			return elm$core$Maybe$Just('4');
		case 5:
			return elm$core$Maybe$Just('5');
		case 6:
			return elm$core$Maybe$Just('6');
		case 7:
			return elm$core$Maybe$Just('7');
		case 8:
			return elm$core$Maybe$Just('8');
		case 9:
			return elm$core$Maybe$Just('9');
		case 10:
			return elm$core$Maybe$Just('10');
		case 11:
			return elm$core$Maybe$Just('11');
		case 12:
			return elm$core$Maybe$Just('12');
		default:
			return elm$core$Maybe$Just('auto');
	}
};
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$colWidthClass = function (_n0) {
	var screenSize = _n0.dT;
	var columnCount = _n0.db;
	return elm$html$Html$Attributes$class(
		'col' + (A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				function (v) {
					return '-' + v;
				},
				rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(screenSize))) + A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				function (v) {
					return '-' + v;
				},
				rundis$elm_bootstrap$Bootstrap$Grid$Internal$columnCountOption(columnCount)))));
};
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$colWidthsToAttributes = function (widths) {
	var width_ = function (w) {
		return A2(elm$core$Maybe$map, rundis$elm_bootstrap$Bootstrap$Grid$Internal$colWidthClass, w);
	};
	return A2(
		elm$core$List$filterMap,
		elm$core$Basics$identity,
		A2(elm$core$List$map, width_, widths));
};
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$defaultColOptions = {a4: elm$core$Maybe$Nothing, a5: elm$core$Maybe$Nothing, a6: elm$core$Maybe$Nothing, a7: elm$core$Maybe$Nothing, a8: elm$core$Maybe$Nothing, bb: _List_Nil, bH: elm$core$Maybe$Nothing, bI: elm$core$Maybe$Nothing, bJ: elm$core$Maybe$Nothing, bL: elm$core$Maybe$Nothing, bM: elm$core$Maybe$Nothing, bS: elm$core$Maybe$Nothing, bT: elm$core$Maybe$Nothing, bU: elm$core$Maybe$Nothing, bV: elm$core$Maybe$Nothing, bW: elm$core$Maybe$Nothing, bZ: elm$core$Maybe$Nothing, b_: elm$core$Maybe$Nothing, b$: elm$core$Maybe$Nothing, b0: elm$core$Maybe$Nothing, b1: elm$core$Maybe$Nothing, b2: elm$core$Maybe$Nothing, b3: elm$core$Maybe$Nothing, b4: elm$core$Maybe$Nothing, b5: elm$core$Maybe$Nothing, b6: elm$core$Maybe$Nothing, ch: elm$core$Maybe$Nothing, aX: elm$core$Maybe$Nothing, aY: elm$core$Maybe$Nothing, aZ: elm$core$Maybe$Nothing, a_: elm$core$Maybe$Nothing, a$: elm$core$Maybe$Nothing};
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$offsetCountOption = function (size) {
	switch (size) {
		case 0:
			return '0';
		case 1:
			return '1';
		case 2:
			return '2';
		case 3:
			return '3';
		case 4:
			return '4';
		case 5:
			return '5';
		case 6:
			return '6';
		case 7:
			return '7';
		case 8:
			return '8';
		case 9:
			return '9';
		case 10:
			return '10';
		default:
			return '11';
	}
};
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$screenSizeToPartialString = function (screenSize) {
	var _n0 = rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(screenSize);
	if (!_n0.$) {
		var s = _n0.a;
		return '-' + (s + '-');
	} else {
		return '-';
	}
};
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$offsetClass = function (_n0) {
	var screenSize = _n0.dT;
	var offsetCount = _n0.dE;
	return elm$html$Html$Attributes$class(
		'offset' + (rundis$elm_bootstrap$Bootstrap$Grid$Internal$screenSizeToPartialString(screenSize) + rundis$elm_bootstrap$Bootstrap$Grid$Internal$offsetCountOption(offsetCount)));
};
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$offsetsToAttributes = function (offsets) {
	var offset_ = function (m) {
		return A2(elm$core$Maybe$map, rundis$elm_bootstrap$Bootstrap$Grid$Internal$offsetClass, m);
	};
	return A2(
		elm$core$List$filterMap,
		elm$core$Basics$identity,
		A2(elm$core$List$map, offset_, offsets));
};
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$orderColOption = function (size) {
	switch (size) {
		case 0:
			return 'first';
		case 1:
			return '1';
		case 2:
			return '2';
		case 3:
			return '3';
		case 4:
			return '4';
		case 5:
			return '5';
		case 6:
			return '6';
		case 7:
			return '7';
		case 8:
			return '8';
		case 9:
			return '9';
		case 10:
			return '10';
		case 11:
			return '11';
		case 12:
			return '12';
		default:
			return 'last';
	}
};
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$orderToAttributes = function (orders) {
	var order_ = function (m) {
		if (!m.$) {
			var screenSize = m.a.dT;
			var moveCount = m.a.ao;
			return elm$core$Maybe$Just(
				elm$html$Html$Attributes$class(
					'order' + (rundis$elm_bootstrap$Bootstrap$Grid$Internal$screenSizeToPartialString(screenSize) + rundis$elm_bootstrap$Bootstrap$Grid$Internal$orderColOption(moveCount))));
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	return A2(
		elm$core$List$filterMap,
		elm$core$Basics$identity,
		A2(elm$core$List$map, order_, orders));
};
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$moveCountOption = function (size) {
	switch (size) {
		case 0:
			return '0';
		case 1:
			return '1';
		case 2:
			return '2';
		case 3:
			return '3';
		case 4:
			return '4';
		case 5:
			return '5';
		case 6:
			return '6';
		case 7:
			return '7';
		case 8:
			return '8';
		case 9:
			return '9';
		case 10:
			return '10';
		case 11:
			return '11';
		default:
			return '12';
	}
};
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$pullsToAttributes = function (pulls) {
	var pull_ = function (m) {
		if (!m.$) {
			var screenSize = m.a.dT;
			var moveCount = m.a.ao;
			return elm$core$Maybe$Just(
				elm$html$Html$Attributes$class(
					'pull' + (rundis$elm_bootstrap$Bootstrap$Grid$Internal$screenSizeToPartialString(screenSize) + rundis$elm_bootstrap$Bootstrap$Grid$Internal$moveCountOption(moveCount))));
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	return A2(
		elm$core$List$filterMap,
		elm$core$Basics$identity,
		A2(elm$core$List$map, pull_, pulls));
};
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$pushesToAttributes = function (pushes) {
	var push_ = function (m) {
		if (!m.$) {
			var screenSize = m.a.dT;
			var moveCount = m.a.ao;
			return elm$core$Maybe$Just(
				elm$html$Html$Attributes$class(
					'push' + (rundis$elm_bootstrap$Bootstrap$Grid$Internal$screenSizeToPartialString(screenSize) + rundis$elm_bootstrap$Bootstrap$Grid$Internal$moveCountOption(moveCount))));
		} else {
			return elm$core$Maybe$Nothing;
		}
	};
	return A2(
		elm$core$List$filterMap,
		elm$core$Basics$identity,
		A2(elm$core$List$map, push_, pushes));
};
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$verticalAlignOption = function (align) {
	switch (align) {
		case 0:
			return 'start';
		case 1:
			return 'center';
		default:
			return 'end';
	}
};
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$vAlignClass = F2(
	function (prefix, _n0) {
		var align = _n0.c7;
		var screenSize = _n0.dT;
		return elm$html$Html$Attributes$class(
			_Utils_ap(
				prefix,
				_Utils_ap(
					A2(
						elm$core$Maybe$withDefault,
						'',
						A2(
							elm$core$Maybe$map,
							function (v) {
								return v + '-';
							},
							rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(screenSize))),
					rundis$elm_bootstrap$Bootstrap$Grid$Internal$verticalAlignOption(align))));
	});
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$vAlignsToAttributes = F2(
	function (prefix, aligns) {
		var align = function (a) {
			return A2(
				elm$core$Maybe$map,
				rundis$elm_bootstrap$Bootstrap$Grid$Internal$vAlignClass(prefix),
				a);
		};
		return A2(
			elm$core$List$filterMap,
			elm$core$Basics$identity,
			A2(elm$core$List$map, align, aligns));
	});
var rundis$elm_bootstrap$Bootstrap$Internal$Text$textAlignDirOption = function (dir) {
	switch (dir) {
		case 1:
			return 'center';
		case 0:
			return 'left';
		default:
			return 'right';
	}
};
var rundis$elm_bootstrap$Bootstrap$Internal$Text$textAlignClass = function (_n0) {
	var dir = _n0.df;
	var size = _n0.ce;
	return elm$html$Html$Attributes$class(
		'text' + (A2(
			elm$core$Maybe$withDefault,
			'-',
			A2(
				elm$core$Maybe$map,
				function (s) {
					return '-' + (s + '-');
				},
				rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(size))) + rundis$elm_bootstrap$Bootstrap$Internal$Text$textAlignDirOption(dir)));
};
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$colAttributes = function (modifiers) {
	var options = A3(elm$core$List$foldl, rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyColOption, rundis$elm_bootstrap$Bootstrap$Grid$Internal$defaultColOptions, modifiers);
	var shouldAddDefaultXs = !elm$core$List$length(
		A2(
			elm$core$List$filterMap,
			elm$core$Basics$identity,
			_List_fromArray(
				[options.a$, options.aZ, options.aY, options.aX, options.a_])));
	return _Utils_ap(
		rundis$elm_bootstrap$Bootstrap$Grid$Internal$colWidthsToAttributes(
			_List_fromArray(
				[
					shouldAddDefaultXs ? elm$core$Maybe$Just(
					A2(rundis$elm_bootstrap$Bootstrap$Grid$Internal$Width, 0, 0)) : options.a$,
					options.aZ,
					options.aY,
					options.aX,
					options.a_
				])),
		_Utils_ap(
			rundis$elm_bootstrap$Bootstrap$Grid$Internal$offsetsToAttributes(
				_List_fromArray(
					[options.bM, options.bJ, options.bI, options.bH, options.bL])),
			_Utils_ap(
				rundis$elm_bootstrap$Bootstrap$Grid$Internal$pullsToAttributes(
					_List_fromArray(
						[options.b1, options.b$, options.b_, options.bZ, options.b0])),
				_Utils_ap(
					rundis$elm_bootstrap$Bootstrap$Grid$Internal$pushesToAttributes(
						_List_fromArray(
							[options.b6, options.b4, options.b3, options.b2, options.b5])),
					_Utils_ap(
						rundis$elm_bootstrap$Bootstrap$Grid$Internal$orderToAttributes(
							_List_fromArray(
								[options.bW, options.bU, options.bT, options.bS, options.bV])),
						_Utils_ap(
							A2(
								rundis$elm_bootstrap$Bootstrap$Grid$Internal$vAlignsToAttributes,
								'align-self-',
								_List_fromArray(
									[options.a8, options.a6, options.a5, options.a4, options.a7])),
							_Utils_ap(
								function () {
									var _n0 = options.ch;
									if (!_n0.$) {
										var a = _n0.a;
										return _List_fromArray(
											[
												rundis$elm_bootstrap$Bootstrap$Internal$Text$textAlignClass(a)
											]);
									} else {
										return _List_Nil;
									}
								}(),
								options.bb)))))));
};
var rundis$elm_bootstrap$Bootstrap$Grid$renderCol = function (column) {
	switch (column.$) {
		case 0:
			var options = column.a.cP;
			var children = column.a.da;
			return A2(
				elm$html$Html$div,
				rundis$elm_bootstrap$Bootstrap$Grid$Internal$colAttributes(options),
				children);
		case 1:
			var e = column.a;
			return e;
		default:
			var options = column.a.cP;
			var children = column.a.da;
			return A3(
				elm$html$Html$Keyed$node,
				'div',
				rundis$elm_bootstrap$Bootstrap$Grid$Internal$colAttributes(options),
				children);
	}
};
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyRowHAlign = F2(
	function (align, options) {
		var _n0 = align.dT;
		switch (_n0) {
			case 0:
				return _Utils_update(
					options,
					{
						bu: elm$core$Maybe$Just(align)
					});
			case 1:
				return _Utils_update(
					options,
					{
						bs: elm$core$Maybe$Just(align)
					});
			case 2:
				return _Utils_update(
					options,
					{
						br: elm$core$Maybe$Just(align)
					});
			case 3:
				return _Utils_update(
					options,
					{
						bq: elm$core$Maybe$Just(align)
					});
			default:
				return _Utils_update(
					options,
					{
						bt: elm$core$Maybe$Just(align)
					});
		}
	});
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyRowVAlign = F2(
	function (align_, options) {
		var _n0 = align_.dT;
		switch (_n0) {
			case 0:
				return _Utils_update(
					options,
					{
						cp: elm$core$Maybe$Just(align_)
					});
			case 1:
				return _Utils_update(
					options,
					{
						cn: elm$core$Maybe$Just(align_)
					});
			case 2:
				return _Utils_update(
					options,
					{
						cm: elm$core$Maybe$Just(align_)
					});
			case 3:
				return _Utils_update(
					options,
					{
						cl: elm$core$Maybe$Just(align_)
					});
			default:
				return _Utils_update(
					options,
					{
						co: elm$core$Maybe$Just(align_)
					});
		}
	});
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyRowOption = F2(
	function (modifier, options) {
		switch (modifier.$) {
			case 2:
				var attrs = modifier.a;
				return _Utils_update(
					options,
					{
						bb: _Utils_ap(options.bb, attrs)
					});
			case 0:
				var align = modifier.a;
				return A2(rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyRowVAlign, align, options);
			default:
				var align = modifier.a;
				return A2(rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyRowHAlign, align, options);
		}
	});
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$defaultRowOptions = {bb: _List_Nil, bq: elm$core$Maybe$Nothing, br: elm$core$Maybe$Nothing, bs: elm$core$Maybe$Nothing, bt: elm$core$Maybe$Nothing, bu: elm$core$Maybe$Nothing, cl: elm$core$Maybe$Nothing, cm: elm$core$Maybe$Nothing, cn: elm$core$Maybe$Nothing, co: elm$core$Maybe$Nothing, cp: elm$core$Maybe$Nothing};
var rundis$elm_bootstrap$Bootstrap$General$Internal$horizontalAlignOption = function (align) {
	switch (align) {
		case 0:
			return 'start';
		case 1:
			return 'center';
		case 2:
			return 'end';
		case 3:
			return 'around';
		default:
			return 'between';
	}
};
var rundis$elm_bootstrap$Bootstrap$General$Internal$hAlignClass = function (_n0) {
	var align = _n0.c7;
	var screenSize = _n0.dT;
	return elm$html$Html$Attributes$class(
		'justify-content-' + (A2(
			elm$core$Maybe$withDefault,
			'',
			A2(
				elm$core$Maybe$map,
				function (v) {
					return v + '-';
				},
				rundis$elm_bootstrap$Bootstrap$General$Internal$screenSizeOption(screenSize))) + rundis$elm_bootstrap$Bootstrap$General$Internal$horizontalAlignOption(align)));
};
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$hAlignsToAttributes = function (aligns) {
	var align = function (a) {
		return A2(elm$core$Maybe$map, rundis$elm_bootstrap$Bootstrap$General$Internal$hAlignClass, a);
	};
	return A2(
		elm$core$List$filterMap,
		elm$core$Basics$identity,
		A2(elm$core$List$map, align, aligns));
};
var rundis$elm_bootstrap$Bootstrap$Grid$Internal$rowAttributes = function (modifiers) {
	var options = A3(elm$core$List$foldl, rundis$elm_bootstrap$Bootstrap$Grid$Internal$applyRowOption, rundis$elm_bootstrap$Bootstrap$Grid$Internal$defaultRowOptions, modifiers);
	return _Utils_ap(
		_List_fromArray(
			[
				elm$html$Html$Attributes$class('row')
			]),
		_Utils_ap(
			A2(
				rundis$elm_bootstrap$Bootstrap$Grid$Internal$vAlignsToAttributes,
				'align-items-',
				_List_fromArray(
					[options.cp, options.cn, options.cm, options.cl, options.co])),
			_Utils_ap(
				rundis$elm_bootstrap$Bootstrap$Grid$Internal$hAlignsToAttributes(
					_List_fromArray(
						[options.bu, options.bs, options.br, options.bq, options.bt])),
				options.bb)));
};
var rundis$elm_bootstrap$Bootstrap$Grid$row = F2(
	function (options, cols) {
		return A2(
			elm$html$Html$div,
			rundis$elm_bootstrap$Bootstrap$Grid$Internal$rowAttributes(options),
			A2(elm$core$List$map, rundis$elm_bootstrap$Bootstrap$Grid$renderCol, cols));
	});
var author$project$Main$view = function (model) {
	return A2(
		rundis$elm_bootstrap$Bootstrap$Grid$container,
		_List_Nil,
		_List_fromArray(
			[
				rundis$elm_bootstrap$Bootstrap$CDN$stylesheet,
				A2(
				rundis$elm_bootstrap$Bootstrap$Grid$row,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						rundis$elm_bootstrap$Bootstrap$Grid$col,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								elm$html$Html$h3,
								_List_fromArray(
									[
										A2(elm$html$Html$Attributes$style, 'margin-top', '2rem'),
										A2(elm$html$Html$Attributes$style, 'font-size', '500%')
									]),
								_List_fromArray(
									[
										elm$html$Html$text(model.H)
									])),
								A2(
								elm$html$Html$div,
								_List_Nil,
								A2(
									elm$core$List$map,
									author$project$Main$viewSong(author$project$Main$Play),
									elm$core$Dict$keys(model.cg))),
								A2(
								elm$html$Html$div,
								_List_Nil,
								A2(
									elm$core$List$map,
									author$project$Main$viewSong(author$project$Main$Generate),
									elm$core$Dict$keys(model.b7)))
							]))
					]))
			]));
};
var elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var elm$browser$Browser$Dom$NotFound = elm$core$Basics$identity;
var elm$core$Basics$never = function (_n0) {
	never:
	while (true) {
		var nvr = _n0;
		var $temp$_n0 = nvr;
		_n0 = $temp$_n0;
		continue never;
	}
};
var elm$core$Task$Perform = elm$core$Basics$identity;
var elm$core$Task$init = elm$core$Task$succeed(0);
var elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			elm$core$Task$andThen,
			function (a) {
				return elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			elm$core$Task$andThen,
			function (a) {
				return A2(
					elm$core$Task$andThen,
					function (b) {
						return elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var elm$core$Task$sequence = function (tasks) {
	return A3(
		elm$core$List$foldr,
		elm$core$Task$map2(elm$core$List$cons),
		elm$core$Task$succeed(_List_Nil),
		tasks);
};
var elm$core$Task$spawnCmd = F2(
	function (router, _n0) {
		var task = _n0;
		return _Scheduler_spawn(
			A2(
				elm$core$Task$andThen,
				elm$core$Platform$sendToApp(router),
				task));
	});
var elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			elm$core$Task$map,
			function (_n0) {
				return 0;
			},
			elm$core$Task$sequence(
				A2(
					elm$core$List$map,
					elm$core$Task$spawnCmd(router),
					commands)));
	});
var elm$core$Task$onSelfMsg = F3(
	function (_n0, _n1, _n2) {
		return elm$core$Task$succeed(0);
	});
var elm$core$Task$cmdMap = F2(
	function (tagger, _n0) {
		var task = _n0;
		return A2(elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager(elm$core$Task$init, elm$core$Task$onEffects, elm$core$Task$onSelfMsg, elm$core$Task$cmdMap);
var elm$core$Task$command = _Platform_leaf('Task');
var elm$core$Task$perform = F2(
	function (toMessage, task) {
		return elm$core$Task$command(
			A2(elm$core$Task$map, toMessage, task));
	});
var elm$core$String$length = _String_length;
var elm$core$String$slice = _String_slice;
var elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			elm$core$String$slice,
			n,
			elm$core$String$length(string),
			string);
	});
var elm$core$String$startsWith = _String_startsWith;
var elm$url$Url$Http = 0;
var elm$url$Url$Https = 1;
var elm$core$String$indexes = _String_indexes;
var elm$core$String$isEmpty = function (string) {
	return string === '';
};
var elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(elm$core$String$slice, 0, n, string);
	});
var elm$core$String$contains = _String_contains;
var elm$core$String$toInt = _String_toInt;
var elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {dm: fragment, dq: host, dF: path, dH: port_, dM: protocol, dN: query};
	});
var elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if (elm$core$String$isEmpty(str) || A2(elm$core$String$contains, '@', str)) {
			return elm$core$Maybe$Nothing;
		} else {
			var _n0 = A2(elm$core$String$indexes, ':', str);
			if (!_n0.b) {
				return elm$core$Maybe$Just(
					A6(elm$url$Url$Url, protocol, str, elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_n0.b.b) {
					var i = _n0.a;
					var _n1 = elm$core$String$toInt(
						A2(elm$core$String$dropLeft, i + 1, str));
					if (_n1.$ === 1) {
						return elm$core$Maybe$Nothing;
					} else {
						var port_ = _n1;
						return elm$core$Maybe$Just(
							A6(
								elm$url$Url$Url,
								protocol,
								A2(elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return elm$core$Maybe$Nothing;
				}
			}
		}
	});
var elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if (elm$core$String$isEmpty(str)) {
			return elm$core$Maybe$Nothing;
		} else {
			var _n0 = A2(elm$core$String$indexes, '/', str);
			if (!_n0.b) {
				return A5(elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _n0.a;
				return A5(
					elm$url$Url$chompBeforePath,
					protocol,
					A2(elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2(elm$core$String$left, i, str));
			}
		}
	});
var elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if (elm$core$String$isEmpty(str)) {
			return elm$core$Maybe$Nothing;
		} else {
			var _n0 = A2(elm$core$String$indexes, '?', str);
			if (!_n0.b) {
				return A4(elm$url$Url$chompBeforeQuery, protocol, elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _n0.a;
				return A4(
					elm$url$Url$chompBeforeQuery,
					protocol,
					elm$core$Maybe$Just(
						A2(elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2(elm$core$String$left, i, str));
			}
		}
	});
var elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if (elm$core$String$isEmpty(str)) {
			return elm$core$Maybe$Nothing;
		} else {
			var _n0 = A2(elm$core$String$indexes, '#', str);
			if (!_n0.b) {
				return A3(elm$url$Url$chompBeforeFragment, protocol, elm$core$Maybe$Nothing, str);
			} else {
				var i = _n0.a;
				return A3(
					elm$url$Url$chompBeforeFragment,
					protocol,
					elm$core$Maybe$Just(
						A2(elm$core$String$dropLeft, i + 1, str)),
					A2(elm$core$String$left, i, str));
			}
		}
	});
var elm$url$Url$fromString = function (str) {
	return A2(elm$core$String$startsWith, 'http://', str) ? A2(
		elm$url$Url$chompAfterProtocol,
		0,
		A2(elm$core$String$dropLeft, 7, str)) : (A2(elm$core$String$startsWith, 'https://', str) ? A2(
		elm$url$Url$chompAfterProtocol,
		1,
		A2(elm$core$String$dropLeft, 8, str)) : elm$core$Maybe$Nothing);
};
var elm$browser$Browser$element = _Browser_element;
var author$project$Main$main = elm$browser$Browser$element(
	{
		ek: function (_n0) {
			return author$project$Main$init;
		},
		ev: author$project$Main$subscriptions,
		ex: author$project$Main$update,
		ez: author$project$Main$view
	});
_Platform_export({'Main':{'init':author$project$Main$main(
	elm$json$Json$Decode$succeed(0))(0)}});}(this));